import $data from '../utils/data'
import _ from 'underscore'
import Main from '@/views/main.vue'
import HomeIndex from '@/views/home'
import MonitorIndex from '@/views/monitor'
import Accounting from '@/views/accounting'
import WorkOrder from '@/views/workOrder'
import weixiuWorkOrder from '@/views/amaiuser/workOrder'
import cusIndex from '@/views/acususer/home'
import CusWorkOrder from '@/views/acususer/workOrder'
import knowledgeBase from '@/views/knowledgeBase'
import weixiuKnowledgeBase from '@/views/amaiuser/knowledgeBase'
import inspection from '@/views/inspection'
import weixiuInspection from '@/views/amaiuser/inspection'
import weiXiuSysTask from '@/views/amaiuser/sysTask'
import PatientWork from '@/views/patientWork'
import consumables from '@/views/consumables'
import consumables_cus from '@/views/acususer/consumables'
import consumables_weixiu from '@/views/amaiuser/consumables'
import offices from '@/views/offices'
import Campus from '@/views/Campus'
import supplier from '@/views/supplier'
import consumablessupplier from '@/views/consumablessupplier'
import Suggestions from '@/views/suggestions'
import sysTask from '@/views/sysTask'
import Customer from '@/views/customer'
import Version from '@/views/version'
import callcenter from '@/views/callcenter'
import device from '@/views/device'
import copyAccounts from '@/views/copyAccounts'
import deviceCus from '@/views/acususer/device'
import deviceWeiXiu from '@/views/amaiuser/device'
import logmanger from '@/views/logmanger'
import facilityTracking from '@/views/internetThings/facilityTracking'
import job from '@/views/job'
import feedback from '@/views/feedback'
import configure from '@/views/configure'
import commondescr from '@/views/commondescr'
import userInfo from '@/views/userInfo'
import developmentlog from '@/views/developmentlog'
import performance from "@/views/performance"
import performanceNew from "@/views/performanceNew"
import performanceAdmin from '@/views/performanceAdmin'
import Hospitalbackstage from '@/views/hospitalbackstage'
import Approvalcenter from '@/views/hospitalbackstage/approvalcenter'
import Commodity from '@/views/shop'
import CommodityType from '@/views/shop/shopType'
import LabelType from '@/views/shop/labelType'
import LogType from '@/views/shop/logType'
import LogisticsType from '@/views/shop/logisticsType'
import OrdersType from '@/views/shop/ordersType'
import { SmsLog } from '@/views/record'
import Analysis from '@/views/dataAnalysis'
import contacts from "@/views/contacts"
import accountingDepartment from "@/views/accountingDepartment"
import projectAdmin from "@/views/project"
import Attendance from "@/views/attendance"
import scheduling from "@/views/scheduling"
import approvalProcess from "@/views/approvalProcess"
import { Tool, Notice, Banner, Auth, Feedback, Config } from '@/views/system'
import temtmain from "@/views/components/base/temtmain"
import messageNotification from "@/views/messageNotification"
import Meeting from "@/views/Meeting"
import inspectionInventory from '@/views/inspectionInventory'
import listOfCharges from '@/views/listOfCharges'
import allIndex from '@/views/allIndex.vue'
import weappPermissionList from '@/views/weappPermissionList'
import deepSeekAI from '@/views/deepSeekAI/index.js'
import Notification from "@/views/notification"

import demand from '@/views/demand/index.js'
import { title } from '../../config'
// import { resolve } from 'core-js/fn/promise'

let customerId = window.localStorage.getItem("customerId")
// 不作为Main组件的子页面展示的页面单独写，如下
export let loginRouter = {}
export let downloadRouter = {
    path: '/fileDownloadList', name: 'fileDownloadList', meta: {
        title: '资源下载',
    }, component: (resolve) => {
        require(['@/views/fileDownloadList.vue'], resolve)
    },
}
export let qyRouter = {
    path: '/weixiuHome', name: 'weixiuHome', meta: {
        title: '错误提示',
    }, component: (resolve) => {
        require(['@/views/weixiuHome.vue'], resolve)
    },
}
export let errorWeiXiuRouter = {
    path: '/weiXiuError', name: 'weiXiuError', meta: {
        title: '错误提示',
    }, component: (resolve) => {
        require(['@/views/weiXiuError.vue'], resolve)
    },
}
export let allIndexRouter = {
    path: '/index', name: "index", meta: {
        title: '首页',
    }, component: (resolve) => {
        require(['@/views/allIndex.vue'], resolve)
    }
}
export let deepSeekAIRouter = {
    path: "/e_ai",
    title: '首页', name: 'e_ai', meta: { title: 'AI' }, component: (resolve) => {
        require(['@/views/deepSeekAI/index.vue'], resolve)
    }

}
if (window.localStorage.getItem("pcFun") == 2 || window.localStorage.getItem("pcFun") == 5) {
    if (window.localStorage.getItem("mainType") == "2") {
        loginRouter = {
            path: '/login', name: 'weixiuHome', meta: {
                title: '登录',
            }, component: (resolve) => {
                require(['@/views/weixiuHome.vue'], resolve)
            },
        }
    } else if (window.localStorage.getItem("mainType") == "3") {
        loginRouter = {
            path: '/login', name: 'cusHome', meta: {
                title: '登录',
            }, component: (resolve) => {
                require(['@/app.vue'], resolve)
            },
        }
    } else if (window.localStorage.getItem("mainType") == "1") {
        loginRouter = {
            path: '/main', name: 'weixiuHome', meta: {
                title: '登录',
            }, component: (resolve) => {
                require(['@/views/weixiuHome.vue'], resolve)
            },
        }
    }
} else {
    loginRouter = {
        path: '/login', name: 'login', meta: {
            title: '登录',
        }, component: (resolve) => {
            require(['@/views/login.vue'], resolve)
        },
    }
}


// 不作为Main组件的子页面展示的页面单独写，如下
// export let largeScreenRouter = {
//     path: '/largeScreen', name: 'largeScreen', meta: {
//         title: '大屏监控',
//     }, component: (resolve) => {
//         require(['@/views/largeScreen.vue'], resolve)
//     },
// }
// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
let _otherRouter = {
    path: '/',
    name: 'otherRouter',
    redirect: '/index',
    component: Main,
    children: [{ path: 'index', title: '首页', name: 'home_index', component: allIndex },
    ],
}
if (window.localStorage.getItem("mainType") == "2") {
    _otherRouter.redirect = '/await_weixiu'
} else if (window.localStorage.getItem("mainType") == "3") {
    _otherRouter.redirect = '/cusIndex'
}
let _weixiuOtherRouter = {
    path: '/',
    name: 'weixiuRouter',
    redirect: '/weixiuIndex',
    component: Main,
    children: [{
        path: 'await_weixiu',
        title: '我的工单',
        name: 'workOrder_await_weixiu',
        component: weixiuWorkOrder.WorkOrderList
    }],
}
let _cusOtherRouter = {
    path: '/',
    name: 'cusRouter',
    redirect: '/cusIndex',
    component: Main,
    children: [{ path: 'cusIndex', title: '首页', name: 'cus_index', component: allIndex }],
}
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
//location.href  ->locatoray 用户信息写到里边，判断用户类型，
//区分用户，维修，管理，path和name后面必须添加_weixiu或者_cus
let _cusRouter = [
    {
        path: '/cusMain',
        icon: 'ios-home-outline',
        name: 'cusHome',
        title: '首页',
        status: false,
        component: Main,
        children: [{
            path: 'cusHome',
            title: '首页',
            name: 'cus_index',
            auth: '',
            component: allIndex
        }],
    },
    {
        path: '/cusWork',
        icon: 'ios-checkbox-outline',
        name: 'cusWork',
        title: '报修',
        status: false,
        component: Main,
        children: [{
            path: 'cusWorkHome',
            title: '报修',
            name: 'cusWorkHome',
            auth: '',
            component: cusIndex.cusIndex
        }],
    },
    {
        path: '/information_cus',
        icon: 'ios-checkbox-outline',
        name: 'information_cus',
        title: '我的报修',
        status: false,
        show: true,
        component: Main,
        children: [
            {
                path: 'await_cus',
                title: '待处理',
                show: true,
                name: 'workOrder_await_cus',
                auth: 'system/workOrder/index',
                component: CusWorkOrder.WorkOrderList,
                status: false,
            }, {
                path: 'processing_cus',
                title: '处理中',
                show: false,
                name: 'workOrder_processing_cus',
                auth: 'system/processing/index',
                component: CusWorkOrder.ProcessingList,
                status: false,

            },
            {
                path: 'completed_cus',
                title: '已完成',
                show: false,
                name: 'workOrder_completed_cus',
                auth: 'system/completed/index',
                component: CusWorkOrder.CompletedList,
                status: false,
            },
            {
                path: 'workOrder_add_cus',
                title: '创建工单',
                show: false,
                status: false,
                name: 'workOrder_add_cus',
                auth: '',
                component: CusWorkOrder.WorkOrderEdit
            },
            {
                path: 'workOrder_info_cus',
                title: '工单详情',
                show: false,
                name: 'workOrder_info_cus',
                auth: '',
                component: CusWorkOrder.WorkOrderInfo,
                status: false
            },
            {
                path: 'workOrder_recyle',
                title: '回收站',
                show: false,
                name: 'workOrder_recyle',
                auth: '',
                component: CusWorkOrder.recycleList,
                status: false
            },
            {
                path: 'repair_cus',
                title: '送修记录',
                show: false,
                name: 'repair_list_cus',
                auth: '',
                component: CusWorkOrder.WorkOrderRepair,
                status: false
            },
            {
                path: 'deviceRecordretrieval_cus',
                title: '入库记录',
                name: 'deviceRecordretrieval_list_cus',
                auth: '',
                show: false,
                component: deviceCus.deviceRecordretrievalListCus
            },
            {
                path: 'deviceRecorddamage_cus',
                title: '损坏记录',
                name: 'deviceRecorddamage_list_cus',
                auth: '',
                show: false,
                component: deviceCus.deviceRecorddamageListCus
            },
            {
                path: 'deviceRecordcheckout_cus',
                title: '出库记录',
                show: false,
                name: 'deviceRecordcheckout_list_cus',
                auth: '',
                component: deviceCus.deviceRecordcheckoutListCus
            },
            {
                path: 'deviceRecordscrap_cus',
                title: '报废记录',
                show: false,
                name: 'deviceRecordscrap_list_cus',
                auth: '',
                component: deviceCus.deviceRecordscrapListCus
            },
            {
                path: 'deviceMaintenance_cus',
                title: '维修记录',
                show: false,
                name: 'deviceMaintenance_list_cus',
                auth: '',
                component: deviceCus.deviceMaintenanceListCus
            },
            {
                path: 'track_cus',
                title: '维修记录',
                show: false,
                name: 'track_list_cus',
                auth: '',
                component: CusWorkOrder.WorkOrderTrack,
                status: false
            },
            {
                path: 'evaluate_cus',
                title: '评价',
                show: false,
                name: 'evaluate_list_cus',
                auth: '',
                component: CusWorkOrder.WorkOrderEvaluate,
                status: false
            },
            {
                path: 'device_cus',
                title: '设备工单详情',
                show: false,
                name: 'device_cus',
                auth: '',
                component: CusWorkOrder.deviceInfoTime,
                status: false
            },
        ],
    },
    {
        path: '/consumables_cus',
        name: 'consumables_cus',
        icon: 'ios-cart-outline',
        title: '物资商城',
        component: Main,
        show: true,
        status: false,
        children: [{
            path: 'consumablesList_cus',
            title: '耗材',
            show: false,
            name: 'consumables_list_cus',
            auth: '',
            component: consumables_cus.consumablesList_cus,
            status: false,
        },],
    },
    {
        path: '/record_cus',
        name: 'record_cus',
        icon: 'ios-clipboard-outline',
        title: '领用记录',
        component: Main,
        show: true,
        status: false,
        children: [{
            path: 'record_list_cus',
            title: '耗材',
            show: true,
            name: 'record_list_cus',
            auth: '',
            component: consumables_cus.recordList_cus,
            status: false,
        },
        {
            path: 'recordInfo_cus',
            title: '耗材领用详情',
            show: false,
            name: 'recordInfo_cus',
            auth: '',
            component: consumables_cus.recordInfo_cus,
            status: false
        },
        ],

    },
]
let _weixiuRouter = [

    {
        path: '/workOrder_weixiu',
        icon: 'ios-copy-outline',
        name: 'workOrder_weixiu',
        title: '我的工单',
        show: true,
        component: Main,
        status: false,
        children: [{
            path: 'await_weixiu',
            title: '待处理',
            show: true,
            name: 'workOrder_await_weixiu',
            auth: '',
            component: weixiuWorkOrder.WorkOrderList,
            status: false,
        }, {
            path: 'processing_weixiu',
            title: '处理中',
            show: true,
            name: 'workOrder_processing_weixiu',
            auth: '',
            component: weixiuWorkOrder.ProcessingList,
            status: false,
        },

        {
            path: 'completed_weixiu',
            title: '已完成',
            show: true,
            name: 'workOrder_completed_weixiu',
            auth: '',
            component: weixiuWorkOrder.CompletedList,
            status: false,
        },
        {
            path: 'seize_weixiu',
            title: '抢单池',
            show: false,
            name: 'seize_weixiu',
            auth: '',
            component: weixiuWorkOrder.seizeList,
            status: false
        },
        {
            path: 'info_weixiu',
            title: '工单详情',
            show: false,
            name: 'workOrder_info_weixiu',
            auth: '',
            component: weixiuWorkOrder.WorkOrderInfo
        },
        {
            path: 'workOrder_recyle',
            title: '回收站',
            show: false,
            name: 'workOrder_recyle',
            auth: '',
            component: WorkOrder.recycleList,
            status: false
        },
        {
            path: 'repair_weixiu',
            title: '送修记录',
            show: false,
            name: 'repair_list_weixiu',
            auth: '',
            component: weixiuWorkOrder.WorkOrderRepair
        },
        {
            path: 'deviceRecordretrieval_weixiu',
            title: '入库记录',
            name: 'deviceRecordretrieval_list_weixiu',
            auth: '',
            show: false,
            component: deviceWeiXiu.deviceRecordretrievalListWeiXiu
        },
        {
            path: 'deviceRecorddamage_weixiu',
            title: '损坏记录',
            name: 'deviceRecorddamage_list_weixiu',
            auth: '',
            show: false,
            component: deviceWeiXiu.deviceRecorddamageListWeiXiu
        },
        {
            path: 'deviceRecordcheckout_weixiu',
            title: '出库记录',
            show: false,
            name: 'deviceRecordcheckout_list_weixiu',
            auth: '',
            component: deviceWeiXiu.deviceRecordcheckoutListWeiXiu
        },
        {
            path: 'deviceRecordscrap_weixiu',
            title: '报废记录',
            show: false,
            name: 'deviceRecordscrap_list_weixiu',
            auth: '',
            component: deviceWeiXiu.deviceRecordscrapListWeiXiu
        },
        {
            path: 'deviceMaintenance_weixiu',
            title: '维修记录',
            show: false,
            name: 'deviceMaintenance_list_weixiu',
            auth: '',
            component: deviceWeiXiu.deviceMaintenanceListWeiXiu
        },
        {
            path: 'track_weixiu',
            title: '维修记录',
            show: false,
            name: 'track_list_weixiu',
            auth: '',
            component: weixiuWorkOrder.WorkOrderTrack
        },
        {
            path: 'evaluate_weixiu',
            title: '评价',
            show: false,
            name: 'evaluate_list_weixiu',
            auth: '',
            component: weixiuWorkOrder.WorkOrderEvaluate
        },
        {
            path: 'change_weixiu',
            title: '转单',
            show: false,
            name: 'change_list_weixiu',
            auth: '',
            component: weixiuWorkOrder.WorkOrderchange
        },
        {
            path: 'device_weixiu',
            title: '设备工单详情',
            show: false,
            name: 'device_weixiu',
            component: weixiuWorkOrder.deviceInfoTime,
            status: false
        },

        ],
    },
    {
        path: '/await_weixiu',
        name: 'await_weixiu',
        title: '工单管理',
        component: Main,
        show: false,
        children: [
            {
                path: 'list_weixiu',
                title: '工单列表',
                name: 'workOrder_list_weixiu',
                auth: 'system/workOrder/index',
                component: weixiuWorkOrder.WorkOrderList
            },
            {
                path: 'devicelist_weixiu',
                title: '资产工单列表',
                name: 'deviceworkOrder_list_weixiu',
                auth: '',
                component: weixiuWorkOrder.deviceWorkOrderList
            },
            {
                path: 'add_weixiu',
                title: '创建工单',
                show: false,
                name: 'workOrder_add_weixiu',
                auth: '',
                component: weixiuWorkOrder.WorkOrderEdit
            },
            {
                path: 'edit_weixiu',
                title: '编辑工单',
                show: false,
                name: 'workOrder_edit_weixiu',
                auth: '',
                component: weixiuWorkOrder.WorkOrderEdit
            },
        ],
    },
    {
        path: '/processing_weixiu',
        name: 'processing_weixiu',
        title: '工单管理',
        component: Main,
        show: false,
        children: [
            {
                path: 'list_weixiu',
                title: '工单列表',
                name: 'processing_list_weixiu',
                auth: 'system/processing/index',
                component: weixiuWorkOrder.ProcessingList
            },
            {
                path: 'edit_weixiu',
                title: '编辑工单',
                show: false,
                name: 'processing_edit_weixiu',
                auth: '',
                component: weixiuWorkOrder.ProcessingEdit
            },
        ],
    },
    {
        path: '/completed_weixiu',
        name: 'completed_weixiu',
        title: '工单管理',
        component: Main,
        show: false,
        children: [
            {
                path: 'list_weixiu',
                title: '工单列表',
                name: 'completed_list_weixiu',
                auth: 'system/completed/index',
                component: weixiuWorkOrder.CompletedList
            },
        ],
    },
    {
        path: '/inspection_weixiu',
        icon: 'md-sync',
        name: 'inspection_weixiu',
        title: '我的巡检',
        component: Main,
        show: true,
        status: false,
        children: [
            {
                path: 'inspectionList_weixiu',
                title: '巡检列表',
                show: true,
                name: 'inspection_list_weixiu',
                auth: 'system/inspection/index',
                component: weixiuInspection.inspectionList,
                status: false,
            },
            {
                path: 'info',
                title: '巡检详情',
                show: false,
                name: 'inspection_info_weixiu',
                auth: '',
                component: weixiuInspection.inspectioninfo,
                status: false,
            },
        ],
    },


    {
        path: 'repair_weixiu',
        title: '送修记录',
        show: false,
        name: 'repair_list_weixiu',
        auth: '',
        component: weixiuWorkOrder.WorkOrderRepair,
        status: false
    },
    {
        path: 'track_weixiu',
        title: '维修记录',
        show: false,
        name: 'track_list_weixiu',
        auth: '',
        component: weixiuWorkOrder.WorkOrderTrack,
        status: false
    },
    {
        path: 'editPro_weixiu',
        title: '填写记录',
        show: false,
        name: 'editPro_weixiu',
        auth: '',
        component: weixiuWorkOrder.WorkOrderEditPro,
        status: false
    },
    {
        path: 'evaluate_weixiu',
        title: '评价',
        show: false,
        name: 'evaluate_list_weixiu',
        auth: '',
        component: weixiuWorkOrder.WorkOrderEvaluate,
        status: false
    },
    {
        path: 'change_weixiu',
        title: '转单',
        show: false,
        name: 'change_list_weixiu',
        auth: '',
        component: weixiuWorkOrder.WorkOrderchange,
        status: false
    },
    {
        path: '/sysTasks_weixiu',
        icon: 'ios-list-box-outline',
        name: 'sysTasks_weixiu',
        title: '我的任务',
        component: Main,
        show: true,
        status: false,
        children: [

            {
                path: 'sysTask_my_weixiu',
                name: 'sysTask_my_weixiu',
                auth: 'system/sysTask/myindex',
                component: weiXiuSysTask.sysTaskList,
                title: '我的任务',
                show: true,
                status: false,
            },
            {
                path: 'Edit_Task_weixiu',
                name: 'Edit_Task_weixiu',
                title: '任务编辑',
                auth: '',
                show: false,
                component: weiXiuSysTask.sysTaskedit
            },
        ]
    },
    {
        path: '/record_weixiu',
        name: 'record_weixiu',
        icon: 'ios-clipboard-outline',
        title: '领用记录',
        component: Main,
        show: true,
        status: false,
        children: [{
            path: 'record_list_weixiu',
            title: '耗材',
            show: true,
            name: 'record_list_weixiu',
            auth: '',
            component: consumables_weixiu.consumablesList_weixiu,
            status: false,
        }, {
            path: 'recordInfo_weixiu',
            title: '耗材领用详情',
            show: false,
            name: 'recordInfo_weixiu',
            auth: '',
            component: consumables_weixiu.recordInfo_weixiu,
            status: false
        },],
    },
]
let _appRouter = [
    // {
    //     path: '/main',
    //     icon: 'ios-home-outline',
    //     name: 'home',
    //     title: '首页',
    //     status: false,
    //     show: true,
    //     component: Main,
    //     children: [{
    //         path: 'home',
    //         title: '首页',
    //         name: 'home_index',
    //         auth: 'system/home/index',
    //         component: HomeIndex.HomeIndex
    //     }],
    // },
    {
        path: '/information',
        icon: 'ios-checkbox-outline',
        name: 'information',
        title: '运维管理',
        isId: 1,
        status: true,
        show: true,
        component: Main,
        children: [
            {
                path: '/simple',
                title: '创建工单',
                show: true,
                auth: 'system/simple/index',
                name: 'simple',
                status: false,
                component: HomeIndex.simple,
            },
            {
                path: '/callcenter',
                title: '呼叫中心',
                show: true,
                auth: 'system/callcenter/index',
                name: 'callcenter',
                status: false,
                component: temtmain,
                children: [
                    {
                        path: 'callcenter_list',
                        title: '电话列表',
                        show: true,
                        name: 'callcenter_list',
                        auth: 'system/callcenter/index',
                        component: callcenter.callcenterList,
                        status: false,
                    },
                    {
                        path: 'callseats',
                        title: '坐席设置',
                        show: true,
                        status: false,
                        name: 'callseats',
                        auth: '',
                        component: callcenter.CallSeatsEdit
                    },
                ]
            },
            {
                path: '/workOrder_admin',
                name: 'workOrder_admin',
                title: '工单中心',
                show: true,
                auth: 'system/workOrder/index',
                component: temtmain,
                status: false,
                children: [{
                    path: 'processing_list',
                    title: '处理中',
                    show: true,
                    name: 'processing_list',
                    auth: 'system/workOrder/index',
                    component: WorkOrder.ProcessingList,
                    status: false,
                },
                {
                    path: 'workOrder_list',
                    title: '待处理',
                    show: true,
                    name: 'workOrder_list',
                    auth: 'system/workOrder/index',
                    component: WorkOrder.WorkOrderList,
                    status: false,
                },
                {
                    path: 'workPending_list',
                    title: '挂起中',
                    show: true,
                    name: 'workPending_list',
                    auth: 'system/workOrder/index',
                    component: WorkOrder.WorkPending,
                    status: false,
                },
                {
                    path: 'completed_list',
                    title: '已完成',
                    show: true,
                    name: 'completed_list',
                    auth: 'system/workOrder/index',
                    component: WorkOrder.CompletedList,
                    status: false,
                },
                {
                    path: 'workOrder_seize',
                    title: '抢单池',
                    show: true,
                    name: 'workOrder_seize',
                    auth: '',
                    component: WorkOrder.seizeList,
                    status: false
                },
                {
                    path: 'workOrder_recyle',
                    title: '回收站',
                    show: true,
                    name: 'workOrder_recyle',
                    auth: '',
                    component: WorkOrder.recycleList,
                    status: false
                },
                {
                    path: 'workOrder_info',
                    title: '工单详情',
                    show: true,
                    name: 'workOrder_info',
                    auth: '',
                    component: WorkOrder.WorkOrderInfo,
                    status: false
                },
                {
                    path: 'workOrder_add',
                    title: '创建工单',
                    show: true,
                    status: false,
                    name: 'workOrder_add',
                    auth: '',
                    component: WorkOrder.WorkOrderEdit
                },
                {
                    path: 'repair',
                    title: '送修记录',
                    show: true,
                    name: 'repair',
                    auth: '',
                    component: WorkOrder.WorkOrderRepair,
                    status: false
                },
                {
                    path: 'track',
                    title: '维修记录',
                    show: true,
                    name: 'track',
                    auth: '',
                    component: WorkOrder.WorkOrderTrack,
                    status: false
                },
                {
                    path: 'editPro',
                    title: '填写记录',
                    show: true,
                    name: 'editPro',
                    auth: '',
                    component: WorkOrder.WorkOrderEditPro,
                    status: false
                },
                {
                    path: 'evaluate',
                    title: '评价',
                    show: true,
                    name: 'evaluate',
                    auth: '',
                    component: WorkOrder.WorkOrderEvaluate,
                    status: false
                },
                {
                    path: 'change',
                    title: '转单',
                    show: true,
                    name: 'change',
                    auth: '',
                    component: WorkOrder.WorkOrderchange,
                    status: false
                },
                ],
            },
            {
                path: '/workOrder_admin_all',
                name: 'workOrder_admin_all',
                title: '全部工单',
                show: customerId == 0 ? true : false,
                auth: '',
                component: temtmain,
                status: false,
                children: [{
                    path: "workOrderAllList",
                    name: "workOrderAllList",
                    title: '全部工单',
                    show: customerId == 0 ? true : false,
                    auth: "",
                    component: WorkOrder.WorkOrderAllList,
                    status: false,
                },
                {
                    path: 'workOrder_info_all',
                    title: '工单详情',
                    show: true,
                    name: 'workOrder_info_all',
                    auth: '',
                    component: WorkOrder.WorkOrderInfo,
                    status: false
                },
                ]
            },
            {
                path: '/demand_management_home',
                name: 'demand_management_home',
                title: '需求管理',
                component: temtmain,
                auth: 'system/demand_management/index',
                show: true,
                status: false,
                children: [
                    {
                        path: 'demand_management_list',
                        title: '所有需求',
                        show: true,
                        name: 'demand_management_list',
                        auth: 'system/demand_management/index',
                        component: demand.allDemand,
                        status: false,
                    },
                    {
                        path: 'demand_management_myTake',
                        title: '我负责的',
                        show: true,
                        name: 'demand_management_myTake',
                        auth: 'system/demand_management/index',
                        component: demand.myTake,
                        status: false,
                    },
                    {
                        path: 'demand_management_mySubmit',
                        title: '我提交的',
                        show: true,
                        name: 'demand_management_mySubmit',
                        auth: 'system/demand_management/index',
                        component: demand.mySubmit,
                        status: false,
                    },
                    {
                        path: "add_demand_management",
                        title: "新增需求",
                        show: true,
                        name: "add_demand_management",
                        auth: "system/demand_management/index",
                        component: demand.addDemand,
                        status: false,
                    },
                    {
                        path: "info_demand_management",
                        title: "需求详情",
                        show: true,
                        name: "info_demand_management",
                        auth: "system/demand_management/index",
                        component: demand.infoDemand,
                        status: false,
                    },
                    {
                        path: "edit_demand_management",
                        title: "处理需求",
                        show: true,
                        name: "edit_demand_management",
                        auth: "system/demand_management/index",
                        component: demand.editDemand,
                        status: false,
                    },
                ]
            },
            {
                path: '/inspection',
                name: 'inspection',
                title: '盘点巡检',
                component: temtmain,
                auth: 'system/inspection/index',
                show: true,
                status: false,
                children: [
                    {
                        path: 'inventoryRecordList',
                        title: '盘点记录',
                        show: true,
                        name: 'inventory_record_list',
                        auth: 'system/inventoryRecordList/index',
                        component: inspection.inventoryRecordList,
                        status: false,
                    },
                    {
                        path: 'activeInspectionList',
                        title: '主动巡检',
                        show: true,
                        name: 'active_inspection_list',
                        auth: 'system/activeInspectionList/index',
                        component: inspection.activeInspectionList,
                        status: false,
                    },
                    {
                        path: 'inspectionList',
                        title: '定时巡检',
                        show: true,
                        name: 'inspection_list',
                        auth: 'system/inspection/index',
                        component: inspection.inspectionList,
                        status: false,
                    },
                    {
                        path: 'inspection_add',
                        title: '创建巡检',
                        show: true,
                        status: false,
                        name: 'inspection_add',
                        auth: '',
                        component: inspection.inspectionEdit
                    },
                    {
                        path: 'check',
                        title: '巡检记录',
                        show: false,
                        name: 'check',
                        auth: '',
                        component: inspection.inspectionCheck,
                        status: false,
                    },
                    {
                        path: 'inspection_info',
                        title: '巡检详情',
                        show: false,
                        name: 'inspection_info',
                        auth: '',
                        component: inspection.inspectioninfo,
                        status: false,
                    },
                ],
            },
            {
                path: '/analysis_index',
                name: 'analysis_index',
                auth: '/admin/analysis/index',
                component: temtmain,
                title: '统计分析',
                show: true,
                status: false,
                children: [

                    {
                        path: 'analysis_index',
                        name: 'analysis_index',
                        auth: '/admin/analysis/index',
                        component: Analysis.AnalysisIndex,
                        title: '统计分析',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'oneinfo_index',
                        name: 'oneinfo_index',
                        auth: '/admin/analysis/index',
                        component: Analysis.OneInfo,
                        title: '报障科室分析',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'fourinfo_index',
                        name: 'fourinfo_index',
                        auth: '/admin/analysis/index',
                        component: Analysis.FourInfo,
                        title: '工单类型分析',
                        show: true,
                        status: false,
                    }, {
                        path: 'fiveinfo_index',
                        name: 'fiveinfo_index',
                        auth: '/admin/analysis/index',
                        component: Analysis.FiveInfo,
                        title: '故障原因分析',
                        show: true,
                        status: false,
                    }, {
                        path: 'threeinfo_index',
                        name: 'threeinfo_index',
                        auth: '/admin/analysis/index',
                        component: Analysis.ThreeInfo,
                        title: '报修渠道分析',
                        show: true,
                        status: false,
                    }, {
                        path: 'seveninfo_index',
                        name: 'seveninfo_index',
                        auth: '/admin/analysis/index',
                        component: Analysis.SevenInfo,
                        title: '报修量&满意度分析',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'eightinfo_index',
                        name: 'eightinfo_index',
                        auth: '/admin/analysis/index',
                        component: Analysis.EightInfo,
                        title: '人员效率分析',
                        show: true,
                        status: false,
                    },
                ]
            },

            {
                path: '/largeScreen_box',
                title: '大屏监控',
                name: 'largeScreen_box',
                auth: '/admin/dashboard/main',
                component: temtmain,
                show: true,
                status: false,
                children: [
                    {
                        path: 'largeScreen',
                        title: '大屏监控',
                        name: 'largeScreen',
                        auth: '/admin/dashboard/main',
                        component: MonitorIndex.MonitorIndex,
                        show: true,
                        status: false,

                    },
                    {
                        path: 'largeScreen_view',
                        title: '大屏监控',
                        name: 'largeScreen_view',
                        auth: '/admin/dashboard/main',
                        component: MonitorIndex.MonitorIndexView,
                        show: true,
                        status: false,

                    },
                ]
            },
            {
                path: '/serveKnowledgeBase',
                name: 'serveKnowledgeBase',
                auth: 'system/commondescr/index',
                component: commondescr.commondescrList,
                title: '服务字典',
                show: true,
                status: false,
            },
            {
                path: '/issueKnowledgeBase_box',
                name: 'issueKnowledgeBase_box',
                auth: 'system/commondescr_issue/index',
                component: temtmain,
                title: '知识库',
                show: true,
                status: false,
                children: [
                    {
                        path: 'issueKnowledgeBase',
                        name: 'issueKnowledgeBase',
                        auth: 'system/commondescr_issue/index',
                        component: commondescr.publicList,
                        title: '知识库',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'auditKnowledgeBase',
                        name: 'auditKnowledgeBase',
                        auth: 'system/commondescr_issue/index',
                        component: commondescr.processList,
                        title: '知识库审核',
                        show: true,
                        status: false,
                    },
                ]
            },
            {
                path: '/inspectionInventory',
                name: 'inspectionInventory',
                title: '巡盘任务',
                component: temtmain,
                auth: 'system/inspection/index',
                show: false,
                status: false,
                children: [
                    {
                        path: 'everyEngineerList',
                        name: 'every_engineer_list',
                        auth: 'system/everyEngineer/index',
                        component: inspectionInventory.everyEngineerList,
                        title: '工程师列表',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'everyInspectionList',
                        name: 'every_inspection_list',
                        auth: '',
                        component: inspectionInventory.everyInspectionList,
                        title: '巡检列表',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'everyInventoryList',
                        name: 'every_inventory_list',
                        auth: '',
                        component: inspectionInventory.everyInventoryList,
                        title: '盘点列表',
                        show: true,
                        status: false,
                    },
                ]
            },

            {
                path: '/workOrder_info',
                title: '工单详情',
                show: false,
                name: 'workOrder_info',
                auth: '',
                component: WorkOrder.WorkOrderInfo,
                status: false
            },
        ],
    },
    {
        path: '/consumables',
        icon: 'ios-grid-outline',
        name: 'consumables',
        title: '物资商城',
        isId: 2,
        component: Main,
        show: true,
        status: true,
        children: [
            // {
            //     path: '/device',
            //     name: 'device',
            //     title: '设备台账',
            //     component: temtmain,
            //     // auth: 'system/deviceretrieval/index',
            //     auth: 'system/device/index',
            //     show: true,
            //     status: false,
            //     children: [
            //         {
            //             path: 'deviceretrieval_list',
            //             title: '使用中',
            //             show: true,
            //             name: 'deviceretrieval_list',
            //             auth: '',
            //             component: device.deviceretrievalList,
            //             status: false,
            //         },
            //         {
            //             path: 'device_list',
            //             title: '库存中',
            //             show: true,
            //             name: 'device_list',
            //             auth: '',
            //             component: device.deviceList,
            //             status: false,
            //         }, {
            //             path: 'devicedamage_list',
            //             title: '已损坏',
            //             show: true,
            //             name: 'devicedamage_list',
            //             auth: '',
            //             component: device.devicedamageList,
            //             status: false,
            //         }, {
            //             path: 'devicescrap_list',
            //             title: '已报废',
            //             show: true,
            //             name: 'devicescrap_list',
            //             auth: '',
            //             component: device.devicescrapList,
            //             status: false,
            //         }, {
            //             path: 'devicestandby_list',
            //             title: '备用库',
            //             show: true,
            //             name: 'devicestandby_list',
            //             auth: '',
            //             component: device.devicestandbyList,
            //             status: false,
            //         }, {
            //             path: 'Emptycode_list',
            //             title: '空码库',
            //             show: true,
            //             name: 'Emptycode_list',
            //             auth: '',
            //             component: device.EmptycodeList,
            //             status: false,
            //         },
            //         {
            //             path: 'device_edit',
            //             title: '编辑',
            //             show: true,
            //             status: false,
            //             name: 'device_edit',
            //             auth: '',
            //             component: device.deviceEdit
            //         },
            //         {
            //             path: 'deviceRecordretrieval_list',
            //             title: '入库记录',
            //             name: 'deviceRecordretrieval_list',
            //             auth: '',
            //             show: true,
            //             status: false,
            //             component: device.deviceRecordretrievalList
            //         },
            //         {
            //             path: 'deviceTakeStockList_list',
            //             title: '盘点记录',
            //             name: 'deviceTakeStockList_list',
            //             auth: '',
            //             show: true,
            //             status: false,
            //             component: device.deviceTakeStockList
            //         },
            //         {
            //             path: 'deviceAssociation_list_cus',
            //             title: '关联记录',
            //             show: true,
            //             status: false,
            //             name: 'deviceAssociation_list_cus',
            //             auth: '',
            //             component: device.deviceAssociation
            //         },
            //         {
            //             path: 'deviceRecorddamage_list',
            //             title: '损坏记录',
            //             name: 'deviceRecorddamage_list',
            //             auth: '',
            //             show: true,
            //             status: false,
            //             component: device.deviceRecorddamageList
            //         },
            //         {
            //             path: 'deviceRecordcheckout_list',
            //             title: '出库记录',
            //             show: true,
            //             status: false,
            //             name: 'deviceRecordcheckout_list',
            //             auth: '',
            //             component: device.deviceRecordcheckoutList
            //         },
            //         {
            //             path: 'deviceRecordscrap_list',
            //             title: '报废记录',
            //             show: true,
            //             status: false,
            //             name: 'deviceRecordscrap_list',
            //             auth: '',
            //             component: device.deviceRecordscrapList
            //         },
            //         {
            //             path: 'deviceMaintenance_list',
            //             title: '维修记录',
            //             show: true,
            //             status: false,
            //             name: 'deviceMaintenance_list',
            //             auth: '',
            //             component: device.deviceMaintenanceList
            //         },
            //         {
            //             path: 'device_add',
            //             title: '创建资产',
            //             show: true,
            //             status: false,
            //             name: 'device_add',
            //             auth: '',
            //             component: device.deviceEdit
            //         },
            //     ],
            // },
            {
                path: '/consumablesIndex',
                title: Number(customerId) == 0 ? '公共仓' : '本地仓',
                show: true,
                name: 'consumablesIndex',
                auth: 'system/consumables/index',
                component: temtmain,
                status: false,
                children: [
                    {
                        path: 'consumablesList',
                        title: '耗材',
                        show: true,
                        name: 'consumables_list',
                        auth: 'system/consumables/index',
                        component: consumables.consumablesList,
                        status: false,
                    },
                    {
                        path: 'consumables_list_admin',
                        title: '公共仓',
                        show: true,
                        name: 'consumables_list_admin',
                        auth: 'system/consumables/index',
                        component: consumables.consumablesListAdmin,
                        status: false,
                    },
                    {
                        path: 'consumables_add',
                        title: '创建耗材',
                        show: true,
                        status: false,
                        name: 'consumables_add',
                        auth: '',
                        component: consumables.consumablesEdit
                    },
                    {
                        path: 'consumables_edit',
                        title: '编辑耗材',
                        show: true,
                        status: false,
                        name: 'consumables_edit',
                        auth: '',
                        component: consumables.consumablesEdit
                    },
                ]
            },
            {
                path: '/change',
                title: '发布',
                show: false,
                name: 'change_list',
                auth: '',
                component: inspection.inspectionchange,
                status: false,
            },
            {
                path: '/device_infotime',
                title: '设备工单详情',
                show: false,
                name: 'device_infotime',
                auth: '',
                component: device.deviceInfoTime,
                status: false
            },
            {
                path: '/inspection_edit',
                title: '编辑巡检',
                show: false,
                name: 'inspection_edit',
                auth: '',
                component: inspection.inspectionEdit
            },
            // {
            //     path: '/consumablesIndexAdmin',
            //     title: '公共仓',
            //     show: false,
            //     name: 'consumablesIndexAdmin',
            //     auth: 'system/consumables/index',
            //     component: temtmain,
            //     status: false,
            //     children: [
            //         {
            //             path: 'consumablesListAdmin',
            //             title: '耗材',
            //             show: true,
            //             name: 'consumables_list_admin',
            //             auth: 'system/consumables/index',
            //             component: consumables.consumablesListAdmin,
            //             status: false,
            //         },
            //     ]
            // },
            {
                path: '/purchaseIndex',
                title: '采购入库',
                show: Number(customerId) !== 0 && Number(customerId) != 174,
                name: 'purchaseIndex',
                auth: 'system/purchaseIndex/index',
                component: temtmain,
                status: false,
                children: [
                    {
                        path: 'purchaseIndex',
                        title: '采购入库',
                        show: Number(customerId) !== 0 && Number(customerId) != 174,
                        name: 'purchaseIndex',
                        auth: 'system/purchaseIndex/index',
                        component: consumables.consumablesPurchase,
                        status: false,
                    },
                    {
                        path: 'ProcureInfo',
                        title: '采购详情',
                        show: true,
                        name: 'ProcureInfo',
                        auth: '',
                        component: consumables.ProcureInfo,
                        status: false,
                    },
                ]
            },
            {
                path: '/device_supplier',
                name: 'device_supplier',
                auth: 'system/devicesupplier/index',
                component: temtmain,
                title: '供应商',
                show: Number(customerId) === 0,
                status: false,
                children: [
                    {
                        path: 'devicesupplier_List',
                        name: 'devicesupplier_List',
                        auth: 'system/devicesupplier/index',
                        component: consumablessupplier.decsupplierList,
                        title: '供应商',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'devicesupplier_edit',
                        title: '编辑供应商',
                        show: true,
                        status: false,
                        name: 'devicesupplier_edit',
                        auth: 'system/supplier/index',
                        component: consumablessupplier.decsupplierEdit
                    },
                    {
                        path: 'devicesupplier_Info',
                        name: 'devicesupplier_Info',
                        title: '供应商详情',
                        show: true,
                        status: false,
                        auth: '',
                        component: consumablessupplier.decsupplierInfo
                    },
                ]
            },
            {
                path: '/purchaseIndexAdmin',
                title: '补货订单',
                show: true,
                name: 'purchaseIndexAdmin',
                auth: 'system/purchaseIndex/index',
                component: consumables.consumablesPurchaseAdmin,
                status: false,
            },
            {
                path: '/PurchaseOrder',
                title: '采购合同',
                show: true,
                name: 'PurchaseOrder',
                auth: 'system/PurchaseOrder/index',
                component: consumables.PurchaseOrderAdmin,
                status: false,

            },
            {
                path: '/recordIndex',
                title: '领用出库',
                show: Number(customerId) !== 0,
                name: 'recordIndex',
                auth: 'system/consumablesrecord/index',
                component: temtmain,
                status: false,
                children: [
                    {
                        path: 'record_list',
                        title: '领用记录',
                        show: true,
                        name: 'record_list',
                        auth: 'system/consumablesrecord/index',
                        component: consumables.recordList,
                        status: false,
                    },
                    {
                        path: 'recordInfo',
                        title: '耗材领用详情',
                        show: true,
                        name: 'recordInfo',
                        auth: '',
                        component: consumables.recordInfo,
                        status: false
                    },

                ]
            },
            {
                path: '/monitoringData',
                title: '数据监测',
                show: Number(customerId) != 174,
                name: 'monitoringData',
                auth: 'system/monitoringData/index',
                component: consumables.monitoringData,
                status: false,
            },
            // {
            //     path: '/supplies_seetings',
            //     title: '设置',
            //     name: 'supplies_seetings',
            //     // auth: '/admin/informationSeetings/index',
            //     auth: '',
            //     component: temtmain,
            //     show: Number(customerId) != 0,
            //     status: false,
            //     children: [
            //         {
            //             path: "approvalProcess_list",
            //             name: "approvalProcess_list",
            //             auth: "",
            //             component: approvalProcess.approvalprocessList,
            //             title: "流程设置",
            //             show: true,
            //             status: false
            //         },
            //         // {
            //         //     path: 'consumablesClass_list',
            //         //     title: '物资分类',
            //         //     show: Number(customerId) == 0,
            //         //     name: 'consumablesClass_list',
            //         //     auth: '',
            //         //     component: consumables.consumablesClassList,
            //         //     status: false,
            //         // },
            //         // {
            //         //     path: 'consumablesClass_add',
            //         //     title: '创建分类',
            //         //     show: true,
            //         //     status: false,
            //         //     name: 'consumablesClass_add',
            //         //     auth: '',
            //         //     component: consumables.consumablesClassEdit
            //         // },
            //         // {
            //         //     path: 'consumablesClass_edit',
            //         //     title: '编辑分类',
            //         //     show: true,
            //         //     status: false,
            //         //     name: 'consumablesClass_edit',
            //         //     auth: '',
            //         //     component: consumables.consumablesClassEdit
            //         // },

            //         {
            //             path: 'ProcessIndex',
            //             title: '流程设置',
            //             show: true,
            //             name: 'ProcessIndex',
            //             auth: '',
            //             component: consumables.ProcessSettings,
            //             status: false,
            //         },
            //         // {
            //         //     path: "/approvalProcess",
            //         //     // icon:""
            //         //     name: "approvalProcess",
            //         //     title: "流程管理",
            //         //     component: temtmain,
            //         //     show: true,
            //         //     status: false,
            //         //     children: [
            //         //         {
            //         //             path: "approvalProcess_list",
            //         //             name: "approvalProcess_list",
            //         //             auth: "",
            //         //             component: approvalProcess.approvalprocessList,
            //         //             title: "流程设置",
            //         //             show: true,
            //         //             status: false
            //         //         }
            //         //     ]
            //         // },
            //     ],
            // },
            // {
            //     path: '/supplies_seetings',
            //     title: '设置',
            //     name: 'supplies_seetings',
            //     // auth: '/admin/informationSeetings/index',
            //     auth: '',
            //     component: temtmain,
            //     show: Number(customerId) == 0,
            //     status: false,
            //     children: [

            //         {
            //             path: 'consumablesClass_list',
            //             title: '物资分类',
            //             show: Number(customerId) == 0,
            //             name: 'consumablesClass_list',
            //             auth: '',
            //             component: consumables.consumablesClassList,
            //             status: false,
            //         },
            //         {
            //             path: "approvalProcess_list",
            //             name: "approvalProcess_list",
            //             auth: "",
            //             component: approvalProcess.approvalprocessList,
            //             title: "流程设置",
            //             show: Number(customerId) != 0,
            //             status: false
            //         },
            //         {
            //             path: 'consumablesClass_add',
            //             title: '创建分类',
            //             show: true,
            //             status: false,
            //             name: 'consumablesClass_add',
            //             auth: '',
            //             component: consumables.consumablesClassEdit
            //         },
            //         {
            //             path: 'consumablesClass_edit',
            //             title: '编辑分类',
            //             show: true,
            //             status: false,
            //             name: 'consumablesClass_edit',
            //             auth: '',
            //             component: consumables.consumablesClassEdit
            //         },
            //         // {
            //         //     path: "/approvalProcess",
            //         //     // icon:""
            //         //     name: "approvalProcess",
            //         //     title: "流程管理",
            //         //     component: temtmain,
            //         //     show: true,
            //         //     status: false,
            //         //     children: [
            //         //         {
            //         //             path: "approvalProcess_list",
            //         //             name: "approvalProcess_list",
            //         //             auth: "",
            //         //             component: approvalProcess.approvalprocessList,
            //         //             title: "流程设置",
            //         //             show: true,
            //         //             status: false
            //         //         }
            //         //     ]
            //         // },
            //     ],
            // },
            {
                path: '/Maintenance',
                title: '订单转单维修员',
                show: false,
                name: 'Maintenance',
                auth: '',
                component: consumables.Maintenance,
                status: false,
            },
        ],
    },
    {
        path: '/messageNotification',
        // icon: 'ios-contacts-outline',
        name: 'messageNotification',
        title: '消息通知',
        component: Main,
        show: false,
        status: true,
        children: [
            {
                path: '/messageNotification_list',
                name: 'messageNotification_list',
                auth: '',
                component: messageNotification.messageList,
                title: '消息通知',
                show: false,
                status: false,
            }
        ]
    },
    {
        path: '/meeting',
        icon: 'ios-people-outline',
        name: 'meeting',
        title: '会议预定',
        isId: 3,
        component: Main,
        show: true,
        status: true,
        children: [
            {
                path: '/scheduleMeeting',
                title: '预定会议',
                name: 'scheduleMeeting',
                auth: 'system/scheduleMeeting/index',
                component: Meeting.scheduleMeeting,
                status: false,
                show: true,
            },
            {
                path: '/MyMeeting',
                title: '我的会议',
                name: 'MyMeeting',
                auth: 'system/MyMeeting/index',
                component: temtmain,
                status: false,
                show: true,
                children: [
                    {
                        path: 'MyMeeting',
                        title: '我的会议',
                        name: 'MyMeeting',
                        auth: 'system/MyMeeting/index',
                        component: Meeting.MyMeeting,
                        status: false,
                        show: true,
                    },
                    {
                        path: 'MeetingList',
                        title: '所有会议',
                        name: 'MeetingList',
                        auth: '',
                        component: Meeting.MeetingList,
                        status: false,
                        show: true,
                    },
                    {
                        path: 'meetingInfo',
                        title: '查看会议详情',
                        name: 'meetingInfo',
                        auth: '',
                        component: Meeting.meetingInfo,
                        status: false,
                        show: true,
                    },
                    {
                        path: 'minute',
                        title: '填写记录',
                        name: 'minute',
                        auth: '',
                        component: Meeting.minute,
                        status: false,
                        show: true,
                    },
                ]
            },
            {
                path: '/MeetingSign',
                title: '会议签到',
                name: 'MeetingSign',
                auth: 'system/MeetingSign/index',
                component: Meeting.MeetingSign,
                status: false,
                show: true,
            },
            {
                path: '/Qiandaobiao',
                title: '会议统计',
                name: 'Qiandaobiao',
                auth: 'system/Qiandaobiao/index',
                component: temtmain,
                status: false,
                show: true,
                children: [
                    {
                        path: 'Qiandaobiao',
                        title: '签到表',
                        name: 'Qiandaobiao',
                        auth: 'system/Qiandaobiao/index',
                        component: Meeting.Qiandaobiao,
                        status: false,
                        show: true,
                    },
                    {
                        path: 'Attendance',
                        title: '出勤率',
                        name: 'Attendance',
                        auth: '',
                        component: Meeting.Attendance,
                        status: false,
                        show: true,
                    },
                ]
            },
            {
                path: '/MeetingRoom',
                title: '会议室',
                name: 'MeetingRoom',
                auth: 'system/MeetingRoom/index',
                component: Meeting.MeetingRoom,
                status: false,
                show: true,
            },
            {
                path: '/MeetingGroup',
                title: '会议组',
                name: 'MeetingGroup',
                auth: 'system/MeetingGroup/index',
                component: Meeting.MeetingGroup,
                status: false,
                show: true,
            },
            {
                path: '/MeetingProcess',
                title: '会议审核',
                name: 'MeetingProcess',
                auth: 'system/MeetingProcess/index',
                component: Meeting.MeetingProcess,
                status: false,
                show: true,
            },
            {
                path: '/addMeeting',
                title: '新增预定会议',
                name: 'addMeeting',
                auth: '',
                component: Meeting.addMeeting,
                status: false,
                show: false,
            },
            {
                path: '/Meetingoperate',
                title: '新增会议室',
                name: 'addMeetingRoom',
                auth: '',
                component: Meeting.addMeetingRoom,
                status: false,
                show: false,
            },
            {
                path: '/addMeetingGroup',
                title: '新增会议组',
                name: 'addMeetingGroup',
                auth: '',
                component: Meeting.addMeetingGroup,
                status: false,
                show: false,
            },
            {
                path: '/signIn',
                title: '签到',
                name: 'signIn',
                auth: '',
                component: Meeting.signIn,
                status: false,
                show: false,
            },
            {
                path: '/addabsent',
                title: '新增缺席',
                name: 'addabsent',
                auth: '',
                component: Meeting.addabsent,
                status: false,
                show: false,
            },
        ],
    },
    {
        path: '/project',
        icon: 'ios-folder-open-outline',
        name: 'project',
        title: '项目管理',
        isId: 4,
        component: Main,
        show: true,
        status: true,
        children: [
            {
                path: '/project_list',
                name: 'project_list',
                title: '项目总览',
                show: true,
                status: false,
                auth: 'system/project/index',
                component: temtmain,
                children: [
                    {
                        path: 'project_list',
                        name: 'project_list',
                        title: '项目',
                        show: true,
                        status: false,
                        auth: 'system/project/index',
                        component: projectAdmin.projectAllList,
                    },
                    {
                        path: 'add_project',
                        name: 'add_project',
                        title: '新增项目',
                        show: true,
                        status: false,
                        auth: 'system/project/index',
                        component: projectAdmin.addproject
                    },
                    {
                        path: 'panorama',
                        name: 'panorama',
                        title: '项目全景',
                        show: true,
                        status: false,
                        auth: 'system/panorama/index',
                        component: projectAdmin.panorama
                    },
                    {
                        path: 'schedule_Info',
                        name: 'schedule_Info',
                        title: '进度',
                        show: true,
                        status: false,
                        auth: 'system/project/index',
                        component: projectAdmin.schedule
                    },
                    {
                        path: 'task_Info',
                        name: 'task_Info',
                        title: '任务',
                        show: true,
                        status: false,
                        auth: 'system/sysTask/index',
                        component: projectAdmin.task
                    },
                    {
                        path: 'add_task',
                        name: 'add_task',
                        title: '新增任务',
                        show: true,
                        status: false,
                        auth: 'system/sysTask/index',
                        component: projectAdmin.addtask
                    },
                    {
                        path: 'supplier_List',
                        name: 'supplier_List',
                        title: Number(customerId) == 0 ? '客户' : '供应商',
                        show: true,
                        auth: 'system/supplier/index',
                        component: projectAdmin.supplier
                    },
                    {
                        path: 'contract_Info',
                        name: 'contract_Info',
                        title: '合同',
                        show: true,
                        auth: 'system/contract/index',
                        component: projectAdmin.contract
                    },
                    {
                        path: 'invoice_Info',
                        name: 'invoice_Info',
                        title: '发票',
                        show: true,
                        auth: 'system/invoice/index',
                        component: projectAdmin.invoice
                    },
                    {
                        path: 'add_contract',
                        name: 'add_contract',
                        title: '新增合同',
                        show: true,
                        auth: 'system/contract/index',
                        component: projectAdmin.addContract
                    },
                    {
                        path: 'add_Invoice',
                        name: 'add_Invoice',
                        title: '新增发票',
                        show: true,
                        auth: 'system/contract/index',
                        component: projectAdmin.addInvoice
                    },
                ]
            },
            {
                path: 'project_list1',
                name: 'project_list1',
                title: Number(customerId) == 0 ? '跟进中' : '建设中',
                show: false,
                status: false,
                auth: '',
                component: projectAdmin.projectList1,
            },
            {
                path: 'project_list2',
                name: 'project_list2',
                title: Number(customerId) == 0 ? '已成交' : '已完成',
                show: false,
                status: false,
                auth: '',
                component: projectAdmin.projectList2,
            },
            {
                path: 'project_list3',
                name: 'project_list3',
                title: '已归档',
                show: false,
                status: false,
                auth: '',
                component: projectAdmin.projectList3,
            },
            {
                path: '/supplier_main',
                name: 'supplier_main',
                auth: 'system/supplier/index',
                component: temtmain,
                title: Number(customerId) == 0 ? '客户管理' : '供应商',
                show: true,
                status: false,
                children: [
                    {
                        path: 'supplier_main',
                        name: 'supplier_main',
                        auth: 'system/supplier/index',
                        component: supplier.supplierList,
                        title: Number(customerId) == 0 ? '客户' : '供应商',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'supplier_edit',
                        title: Number(customerId) == 0 ? '编辑客户' : '编辑供应商',
                        show: true,
                        status: false,
                        name: 'supplier_edit',
                        auth: 'system/supplier/index',
                        component: supplier.supplierEdit,
                    },
                    {
                        path: 'supplier_Info',
                        name: 'supplier_Info',
                        title: Number(customerId) == 0 ? '客户详情' : '供应商详情',
                        show: true,
                        status: false,
                        auth: 'system/supplier/index',
                        component: projectAdmin.supplierInfo
                    },
                ]
            },
            {
                path: '/contract_Info_all',
                name: 'contract_Info_all',
                title: '合同管理',
                show: true,
                status: false,
                auth: 'system/contract/index',
                component: temtmain,
                children: [
                    {
                        path: 'contract_Info_all',
                        name: 'contract_Info_all',
                        title: '合同',
                        show: true,
                        status: false,
                        auth: 'system/contract/index',
                        component: projectAdmin.contractList,
                    },
                    {
                        path: 'add_contract_all',
                        name: 'add_contract_all',
                        title: '新增合同',
                        show: true,
                        status: false,
                        auth: 'system/contract/index',
                        component: projectAdmin.contractEditAll
                    },
                    {
                        path: 'add_contractInvoice',
                        name: 'add_contractInvoice',
                        title: '新增合同发票',
                        show: true,
                        auth: 'system/invoice/index',
                        component: projectAdmin.addcontractInvoice
                    },
                    {
                        path: 'ContractInvoice_list',
                        name: 'ContractInvoice_list',
                        title: '发票列表',
                        show: true,
                        auth: 'system/contract/index',
                        component: projectAdmin.contractInvoicelist
                    },
                ]
            },
            {
                path: '/sysTasks',
                // icon: 'ios-list-box-outline',
                name: 'sysTasks',
                title: '任务管理',
                auth: 'system/sysTask/index',
                component: temtmain,
                show: true,
                status: false,
                children: [
                    {
                        path: 'sysTask_info',
                        name: 'sysTask_info',
                        auth: 'system/sysTask/index',
                        component: sysTask.sysTaskList,
                        title: '任务列表',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'sysTask_my',
                        name: 'sysTask_my',
                        auth: 'system/sysTask/myindex',
                        component: sysTask.sysMyTaskList,
                        title: '我的任务',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'Edit_Task',
                        name: 'Edit_Task',
                        title: '任务编辑',
                        auth: '',
                        show: true,
                        component: sysTask.sysTaskedit
                    },
                    {
                        path: 'Info_Task',
                        name: 'Info_Task',
                        title: '任务查看',
                        auth: '',
                        show: true,
                        component: sysTask.sysTaskInfo,
                        status: false,
                    },

                ]
            },
            {
                path: '/invoice_List',
                name: 'invoice_List',
                title: '发票管理',
                show: true,
                status: false,
                auth: 'system/invoice/index',
                component: temtmain,
                children: [
                    {
                        path: 'invoice_List',
                        name: 'invoice_List',
                        title: '发票',
                        show: true,
                        status: false,
                        auth: 'system/invoice/index',
                        component: projectAdmin.invoiceList
                    },
                    {
                        path: 'add_invoice',
                        name: 'add_invoice',
                        title: '新增发票',
                        show: true,
                        status: false,
                        auth: 'system/invoice/index',
                        component: projectAdmin.addInvoice
                    },
                ]
            },
            {
                path: '/Process_List',
                name: 'Process_List',
                title: '项目流程',
                show: true,
                status: false,
                auth: 'system/Process/index',
                component: temtmain,
                children: [
                    {
                        path: 'Process_List',
                        name: 'Process_List',
                        title: '项目流程',
                        show: true,
                        status: false,
                        auth: 'system/Process/index',
                        component: projectAdmin.ProcessList
                    },
                    {
                        path: 'add_Process',
                        name: 'add_Process',
                        title: '新增项目流程',
                        show: true,
                        status: false,
                        auth: 'system/invoice/index',
                        component: projectAdmin.addProcess
                    },
                ]
            },
            {
                path: '/listOfCharges_list',
                name: 'listOfCharges_list',
                title: '收费清单',
                component: temtmain,
                auth: '/admin/listOfCharges/index',
                show: Number(customerId) != 0 ? true : false,
                status: false,
                children: [
                    {
                        path: 'listOfCharges_list',
                        name: 'listOfCharges_list',
                        title: '收费清单',
                        component: listOfCharges.listOfChargesList,
                        auth: '/admin/listOfCharges/index',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'summarizing_list',
                        name: 'summarizing_list',
                        title: '汇总',
                        component: listOfCharges.summarizingList,
                        auth: '/admin/listOfCharges/index',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'account_stated',
                        title: '明细',
                        show: true,
                        name: 'account_stated',
                        auth: '/admin/listOfCharges/index',
                        component: listOfCharges.accountStated,
                        status: false,
                    },
                    {
                        path: "rate_list",
                        title: "费率",
                        show: true,
                        name: "rate_list",
                        auth: "/admin/listOfCharges/index",
                        component: listOfCharges.rateList,
                        status: false,
                    },
                ]
            },
            {
                path: "/customer_list_table",
                title: "收费清单",
                show: Number(customerId) === 0 ? true : false,
                name: "customer_list_table",
                auth: "/admin/customerListTable/index",
                component: temtmain,
                status: false,
                children: [
                    {
                        path: "customer_list_table",
                        title: "收费清单",
                        show: true,
                        name: "customer_list_table",
                        auth: "/admin/customerListTable/index",
                        component: listOfCharges.customerListTable,
                        status: false,
                    },
                    {
                        path: "edit_rate",
                        title: "新增费率",
                        show: true,
                        name: "edit_rate",
                        auth: "/admin/editRate/index",
                        component: listOfCharges.editRate,
                        status: false,
                    },
                ]
            },
            {
                path: '/costing_list',
                name: 'costing_list',
                title: '成本核算',
                component: temtmain,
                auth: '/admin/costing/index',
                show: Number(customerId) == 0 ? true : false,
                status: false,
                children: [
                    {
                        path: 'costing_list',
                        name: 'costing_list',
                        title: '本月利润',
                        component: projectAdmin.Monthlyprofit,
                        auth: '/admin/costing/index',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'Consumablescost_list',
                        name: 'Consumablescost_list',
                        title: '耗材成本',
                        component: projectAdmin.Consumablescost,
                        auth: '/admin/costing/index',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'Cost_list',
                        name: 'Cost_list',
                        title: '服务成本',
                        component: projectAdmin.Cost,
                        auth: '/admin/costing/index',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'MonthlyIncome_list',
                        name: 'MonthlyIncome_list',
                        title: '当月收入',
                        component: projectAdmin.MonthlyIncome,
                        auth: '/admin/costing/index',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'Commissions_list',
                        name: 'Commissions_list',
                        title: '销售佣金',
                        component: projectAdmin.Commissions,
                        auth: '/admin/costing/index',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'add_Cost',
                        name: 'add_Cost',
                        title: '新增服务成本',
                        component: projectAdmin.addCost,
                        auth: '/admin/costing/index',
                        status: false,
                    },
                    {
                        path: 'editCommissions',
                        name: 'editCommissions',
                        title: '编辑销售佣金',
                        component: projectAdmin.editCommissions,
                        auth: '/admin/costing/index',
                        status: false,
                    },
                    {
                        path: 'add_MonthlyIncome',
                        name: 'add_MonthlyIncome',
                        title: '新增当月收入',
                        component: projectAdmin.addMonthlyIncome,
                        auth: '/admin/costing/index',
                        status: false,
                    },
                    {
                        path: 'add_Commissions',
                        name: 'add_Commissions',
                        title: '新增销售佣金',
                        component: projectAdmin.addCommissions,
                        auth: '/admin/costing/index',
                        status: false,
                    },
                    {
                        path: 'saleInfoList',
                        name: 'saleInfoList',
                        title: '新增销售佣金',
                        component: projectAdmin.saleInfoList,
                        auth: '/admin/costing/index',
                        status: false,
                    },
                ]
            },
            {
                path: '/Statistics_List',
                name: 'Statistics_List',
                title: '统计分析',
                show: true,
                status: false,
                auth: 'system/Statistics/index',
                component: temtmain,
                children: [
                    {
                        path: 'Statistics_List',
                        name: 'Statistics_List',
                        title: '统计分析',
                        show: true,
                        status: false,
                        auth: 'system/Statistics/index',
                        component: projectAdmin.Statistics
                    }
                ]
            },
        ]
    },

    {
        path: '/internetThings',
        icon: 'ios-link-outline',
        name: 'internetThings',
        title: '生活服务',
        isId: 5,
        component: Main,
        status: true,
        show: true,
        children: [
            {
                path: '/facilityTracking1',
                title: '智慧餐饮',
                name: 'facilityTracking1',
                show: true,
                status: false,
                auth: '/system/facilityTracking/list',
                url: "https://saas.pc.goliveplus.cn/home/homePage?username=15026682657&password=6FrnWKXrUK9s5tvePd4pdw==",
                component: facilityTracking.facilityTrackingList
            },
            {
                path: '/facilityTracking2',
                title: '智慧门禁',
                name: 'facilityTracking2',
                show: true,
                status: false,
                auth: '/system/facilityTracking/list',
                url: "https://saas.pc.goliveplus.cn/home/homePage?username=15026682657&password=6FrnWKXrUK9s5tvePd4pdw==",
                component: facilityTracking.facilityTrackingList
            }, {
                path: '/facilityTracking3',
                title: '充电保',
                name: 'facilityTracking3',
                show: true,
                status: false,
                auth: '/system/facilityTracking/list',
                url: "https://saas.pc.goliveplus.cn/home/homePage?username=15026682657&password=6FrnWKXrUK9s5tvePd4pdw==",
                component: facilityTracking.facilityTrackingList
            }, {
                path: '/facilityTracking4',
                title: '青易充',
                name: 'facilityTracking4',
                show: true,
                status: false,
                auth: '/system/facilityTracking/list',
                url: "https://saas.pc.goliveplus.cn/home/homePage?username=15026682657&password=6FrnWKXrUK9s5tvePd4pdw==",
                component: facilityTracking.facilityTrackingList
            },
        ],
    },
    {
        path: '/contacts',
        icon: 'ios-contacts-outline',
        name: 'contacts',
        title: '科室管理',
        isId: 6,
        component: Main,
        show: true,
        status: true,
        children: [
            {
                path: '/contacts_list',
                name: 'contacts_list',
                auth: 'system/offices/index',
                component: contacts.contactsList,
                title: '通讯录',
                show: true,
                status: false,
            },
            {
                path: '/auth_group_list',
                title: '角色权限',
                name: 'auth_group_list',
                auth: '/admin/authgroup/lists',
                show: true,
                component: temtmain,
                status: false,
                children: [
                    {
                        path: 'auth_group_list',
                        title: '角色权限',
                        name: 'auth_group_list',
                        auth: '/admin/authgroup/lists',
                        show: true,
                        component: Auth.AuthGroupList,
                        status: false
                    },
                    {
                        path: 'weapp_client_list_item',
                        title: '用户菜单',
                        name: 'weapp_client_list_item',
                        auth: '/admin/authgroup/lists',
                        show: true,
                        component: weappPermissionList.clientListAll,
                        status: false
                    },
                    {
                        path: 'weapp_engineer_list_item',
                        title: '维修菜单',
                        name: 'weapp_engineer_list_item',
                        auth: '/admin/authgroup/lists',
                        show: true,
                        component: weappPermissionList.engineerListAll,
                        status: false
                    },
                    {
                        path: 'weapp_edit_item',
                        title: '编辑菜单',
                        name: 'weapp_edit_item',
                        auth: '/admin/authgroup/lists',
                        show: true,
                        component: weappPermissionList.editAll,
                        status: false
                    },
                    {
                        path: 'auth_group_add',
                        title: '创建权限组',
                        show: true,
                        name: 'auth_group_add',
                        auth2: '',
                        component: Auth.AuthGroupEdit,
                        status: false,
                    },
                    {
                        path: 'auth_group_edit',
                        title: '编辑权限组',
                        show: true,
                        name: 'auth_group_edit',
                        auth2: '',
                        component: Auth.AuthGroupEdit,
                        status: false,
                    },
                ]
            },
            {
                path: "/scheduling",
                // icon: "ios-pin-outline",
                name: "scheduling",
                title: "排班管理",
                component: temtmain,
                auth: 'system/scheduling/index',
                show: true,
                status: false,
                children: [
                    {
                        path: "scheduling_list",
                        name: "scheduling_list",
                        auth: '',
                        component: scheduling.schedulingList,
                        title: "排班管理",
                        show: true,
                        status: false
                    },
                    {
                        path: "scheduling_details",
                        name: "scheduling_details",
                        auth: '',
                        component: scheduling.schedulingDetails,
                        title: "排班详情",
                        show: true,
                        status: false,
                    },
                    {
                        path: "attendance_list",
                        name: "attendance_list",
                        auth: '',
                        component: Attendance.AttendanceList,
                        title: "考勤组管理",
                        show: true,
                        status: false
                    }
                ]
            },
            {
                path: '/offices_building_list',
                name: 'offices_building_list',
                auth: 'system/building/index',
                component: temtmain,
                title: '楼宇设置',
                show: true,
                status: false,
                children: [
                    {
                        path: 'offices_building_list',
                        name: 'offices_building_list',
                        auth: 'system/building/index',
                        component: offices.buildinglist,
                        title: '楼宇楼层',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'offices_building_edit',
                        title: '楼栋编辑',
                        show: true,
                        status: false,
                        name: 'offices_building_edit',
                        auth: '',
                        component: offices.buildEdit
                    },
                    {
                        path: 'offices_floor_edit',
                        title: '楼层编辑',
                        show: true,
                        status: false,
                        name: 'offices_floor_edit',
                        auth: '',
                        component: offices.floorEdit
                    },
                ]
            },
            {
                path: '/accountingList_list',
                name: 'accountingList_list',
                auth: 'system/accountingList/index',
                component: temtmain,
                title: '核算科室',
                show: true,
                status: false,
                children: [
                    {
                        path: '/accountingList_list',
                        name: 'accountingList_list',
                        auth: 'system/accountingList/index',
                        component: accountingDepartment.accountingList,
                        title: '核算科室',
                        show: true,
                        status: false,
                    }
                ]
            },
            {
                path: '/Campus_list',
                name: 'Campus_list',
                auth: 'system/Campus/index',
                component: temtmain,
                title: '院区管理',
                show: true,
                status: false,
                children: [
                    {
                        path: 'Campus_list',
                        name: 'Campus_list',
                        auth: 'system/Campus/index',
                        component: Campus.Campuslist,
                        title: '院区列表',
                        show: true,
                        status: false,
                    },
                ]
            },
            {
                path: '/worktype_list_warp',
                name: 'worktype_list_warp',
                auth: 'system/worktype/index',
                component: temtmain,
                title: '工单类型',
                show: true,
                status: false,
                children: [
                    {
                        path: 'worktype_list',
                        title: '工单类型',
                        name: 'worktype_list',
                        auth: 'system/worktype/index',
                        component: WorkOrder.worktypeList,
                        status: false,
                        show: true,
                    },
                    {
                        path: 'worktype_add',
                        title: '创建工单类型',
                        show: true,
                        status: false,
                        name: 'worktype_add',
                        auth: '',
                        component: WorkOrder.worktypeEdit
                    },
                    {
                        path: 'worktype_edit',
                        title: '编辑工单类型',
                        show: true,
                        status: false,
                        name: 'worktype_edit',
                        auth: '',
                        component: WorkOrder.worktypeEdit
                    },
                ]
            },
            {
                path: '/category_list_warp',
                name: 'category_list_warp',
                auth: 'system/category/index',
                component: temtmain,
                title: '巡检类别',
                show: true,
                status: false,
                children: [
                    {
                        path: 'category_list',
                        title: '巡检类别',
                        show: true,
                        name: 'category_list',
                        auth: 'system/category/index',
                        component: inspection.categoryList,
                        status: false,
                    },
                    {
                        path: 'category_edit',
                        title: '新增巡检类别',
                        show: true,
                        name: 'category_edit',
                        auth: 'system/category/index',
                        component: inspection.categoryEdit,
                        status: false,
                    },
                ]
            },
            {
                path: '/scene_list_warp',
                name: 'scene_list_warp',
                auth: 'system/scene/index',
                component: temtmain,
                title: '巡检项',
                show: true,
                status: false,
                children: [
                    {
                        path: 'scene_list',
                        title: '巡检项',
                        show: true,
                        name: 'scene_list',
                        auth: 'system/scene/index',
                        component: device.sceneList,
                        status: false,
                    },
                    { path: 'scene_add', title: '创建场景', show: true, status: false, name: 'scene_add', auth: '', component: device.sceneEdit },
                    {
                        path: 'scene_edit',
                        title: '编辑场景',
                        show: true,
                        status: false,
                        name: 'scene_edit',
                        auth2: '',
                        component: device.sceneEdit
                    },
                ]
            },
            {
                path: '/commondescr_list_main_warp',
                name: 'commondescr_list_main_warp',
                auth: 'system/commondescrContext/index',
                component: temtmain,
                title: '常用语',
                show: true,
                status: false,
                children: [
                    {
                        path: 'commondescr_list_main',
                        name: 'commondescr_list_main',
                        auth: 'system/commondescrContext/index',
                        component: commondescr.commondescrListMain,
                        title: '常用语',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'commondescr_add_main',
                        title: '创建语句',
                        show: true,
                        status: false,
                        name: 'commondescr_add_main',
                        auth: '',
                        component: commondescr.commondescrEditMain
                    },
                ]
            },
            {
                path: '/callConfig_list_warp',
                name: 'callConfig_list_warp',
                auth: '/admin/callConfig/lists',
                component: temtmain,
                title: '坐席设置',
                show: true,
                status: false,
                children: [
                    {
                        path: 'callConfig_list',
                        title: '坐席列表',
                        name: 'callConfig_list',
                        auth: '/admin/callConfig/lists',
                        component: callcenter.callConfigList,
                        show: true,
                        status: false
                    },
                    {
                        path: 'callConfig_edit',
                        title: '坐席编辑',
                        name: 'callConfig_edit',
                        auth: '',
                        component: callcenter.callConfigEdit,
                        show: true,
                        status: false
                    },
                ]
            },
            {
                path: '/deviceClass_list_warp',
                name: 'deviceClass_list_warp',
                auth: 'system/deviceClass_list/index',
                component: temtmain,
                title: '资产类型',
                show: true,
                status: false,
                children: [
                    {
                        path: 'deviceClass_list',
                        title: '资产类型',
                        show: true,
                        name: 'deviceClass_list',
                        auth: 'system/deviceClass_list/index',
                        component: device.deviceClassList,
                        status: false,
                    },
                    {
                        path: 'deviceClass_add',
                        title: '创建分类',
                        show: true,
                        status: false,
                        name: 'deviceClass_add',
                        auth: '',
                        component: device.deviceClassEdit
                    },
                    {
                        path: 'deviceClass_edit',
                        title: '编辑分类',
                        show: true,
                        status: false,
                        name: 'deviceClass_edit',
                        auth: '',
                        component: device.deviceClassEdit
                    },
                ]
            },
            {
                path: '/deviceType_list_warp',
                name: 'deviceType_list_warp',
                auth: 'system/deviceType_list/index',
                component: temtmain,
                title: '型号库',
                show: true,
                status: false,
                children: [
                    {
                        path: 'deviceType_list',
                        title: '型号库',
                        name: 'deviceType_list',
                        auth: 'system/deviceType_list/index',
                        component: device.deviceTypeList,
                        show: true,
                        status: false
                    },
                    {
                        path: 'deviceType_edit',
                        title: '新增设备型号',
                        name: 'deviceType_edit',
                        auth: '',
                        component: device.deviceTypeEdit,
                        show: true,
                        status: false,
                    },
                ]
            },
            {
                path: '/approvalProcess_list_warp',
                name: 'approvalProcess_list_warp',
                auth: 'system/approvalProcess_list/index',
                component: temtmain,
                title: '流程管理',
                show: true,
                status: false,
                children: [
                    {
                        path: "approvalProcess_list",
                        name: "approvalProcess_list",
                        auth: "system/approvalProcess_list/index",
                        component: approvalProcess.approvalprocessList,
                        title: "流程设置",
                        show: true,
                        status: false
                    },
                    {
                        path: 'ProcessIndex',
                        title: '流程设置',
                        show: Number(customerId) == 0,
                        name: 'ProcessIndex',
                        auth: '',
                        component: consumables.ProcessSettings,
                        status: false,
                    },
                ]
            },
            {
                path: '/consumablesClass_list_warp',
                name: 'consumablesClass_list_warp',
                auth: 'system/consumablesClass_list/index',
                component: temtmain,
                title: '物资分类',
                show: Number(customerId) == 0,
                status: false,
                children: [
                    {
                        path: 'consumablesClass_list',
                        title: '物资分类',
                        show: Number(customerId) == 0,
                        name: 'consumablesClass_list',
                        auth: 'system/consumablesClass_list/index',
                        component: consumables.consumablesClassList,
                        status: false,
                    },
                    {
                        path: 'consumablesClass_add',
                        title: '创建分类',
                        show: true,
                        status: false,
                        name: 'consumablesClass_add',
                        auth: '',
                        component: consumables.consumablesClassEdit
                    },
                    {
                        path: 'consumablesClass_edit',
                        title: '编辑分类',
                        show: true,
                        status: false,
                        name: 'consumablesClass_edit',
                        auth: '',
                        component: consumables.consumablesClassEdit
                    },
                ]
            },
            {
                path: "/engineer_notification",
                title: "通知管理",
                show: customerId == 0 ? true : false,
                name: "engineer_notification",
                auth: "admin/engineer_notification/index",
                component: temtmain,
                status: false,
                children: [
                    {
                        path: "engineer_notification_list",
                        title: "公告列表",
                        show: true,
                        name: "engineer_notification_list",
                        auth: "admin/engineer_notification/index",
                        component: Notification.notificationList,
                        status: false
                    },
                    {
                        path: "engineer_notification_edit",
                        title: "公告列表",
                        show: true,
                        name: "engineer_notification_edit",
                        auth: "admin/engineer_notification/index",
                        component: Notification.notificationEdit,
                        status: false
                    }
                ]
            },
            {
                path: '/performance_admin',
                // icon: "ios-stats-outline",
                title: '绩效规则',
                name: 'performance_admin',
                component: temtmain,
                auth: 'system/performance_admin/index',
                show: Number(customerId) === 0 ? true : false,
                status: false,
                children: [
                    {
                        path: 'performance_admin_list',
                        title: '绩效列表',
                        name: 'performance_admin_list',
                        auth: 'system/performance_admin/index',
                        component: performanceAdmin.performanceRulesList,
                        show: true,
                        status: false,
                    },
                    {
                        path: 'performance_admin_info',
                        title: '规则详情',
                        name: 'performance_admin_info',
                        auth: 'system/performance_admin/index',
                        component: performanceAdmin.performanceRuleInfo,
                        show: true,
                        status: false,
                    },
                    {
                        path: 'performance_admin_engineer',
                        title: '工程师规则',
                        name: 'performance_admin_engineer',
                        auth: 'system/performance_admin/index',
                        component: performanceAdmin.engineerRuleEdit,
                        show: true,
                        status: false,
                    },
                    {
                        path: 'performance_admin_edit',
                        title: '绩效设置',
                        name: 'performance_admin_edit',
                        auth: 'system/performance_admin/index',
                        component: performanceAdmin.allEdit,
                        show: true,
                        status: false,
                    }

                ]
            },
        ]
    },
    {
        path: '/analysis',
        icon: 'ios-analytics-outline',
        name: 'analysis',
        title: '数据中心',
        isId: 7,
        component: Main,
        show: true,
        status: true,
        children: [
            // {
            //     path: '/analysis_index',
            //     name: 'analysis_index',
            //     auth: '/admin/analysis/index',
            //     component: Analysis.AnalysisIndex,
            //     title: '统计分析',
            //     show: true,
            //     status: false,
            // },
            // {
            //     path: "/service_reporting",
            //     name: "service_reporting",
            //     auth: "/admin/reporting/index",
            //     component: Analysis.serviceReportingIndex,
            //     title: "服务报告",
            //     show: true,
            //     status: false
            // },
            // {
            //     path: '/largeScreen',
            //     title: '大屏监控',
            //     name: 'monitor_index',
            //     auth: '/admin/dashboard/main',
            //     component: MonitorIndex.MonitorIndex,
            //     show: true,
            //     status: false,
            // },
            // {
            //     path: '/oneinfo_index',
            //     name: 'oneinfo_index',
            //     auth: '',
            //     component: Analysis.OneInfo,
            //     title: '报障科室分析',
            //     show: false,
            //     status: false,
            // },
            // {
            //     path: '/eightinfo_index',
            //     name: 'eightinfo_index',
            //     auth: '',
            //     component: Analysis.EightInfo,
            //     title: '人员效率分析',
            //     show: false,
            //     status: false,
            // },
            // {
            //     path: '/fourinfo_index',
            //     name: 'fourinfo_index',
            //     auth: '',
            //     component: Analysis.FourInfo,
            //     title: '工单类型分析',
            //     show: false,
            //     status: false,
            // }, {
            //     path: '/fiveinfo_index',
            //     name: 'fiveinfo_index',
            //     auth: '',
            //     component: Analysis.FiveInfo,
            //     title: '故障原因分析',
            //     show: false,
            //     status: false,
            // }, {
            //     path: '/threeinfo_index',
            //     name: 'threeinfo_index',
            //     auth: '',
            //     component: Analysis.ThreeInfo,
            //     title: '报修渠道分析',
            //     show: false,
            //     status: false,
            // }, {
            //     path: '/seveninfo_index',
            //     name: 'seveninfo_index',
            //     auth: '',
            //     component: Analysis.SevenInfo,
            //     title: '报修量&满意度分析',
            //     show: false,
            //     status: false,
            // }
        ],
    },
    //  {
    //     path: '/suggestions',
    //     icon: 'ios-bulb-outline',
    //     name: 'suggestions',
    //     title: '改善建议',
    //     component: Main,
    //     show: false,
    //     status: false,
    //     children: [
    //         {
    //             path: 'suggestions_list',
    //             name: 'suggestions_list',
    //             auth: 'system/suggestions/list',
    //             component: Suggestions.SuggestionsList,
    //             title: '建议列表',
    //             show: true,
    //             status: false,
    //         },
    //         {
    //             path: 'suggestions_add',
    //             name: 'suggestions_add',
    //             auth: '',
    //             component: Suggestions.SuggestionsEdit,
    //             title: '新增建议',
    //             show: true,
    //             status: false,
    //         },
    //     ]
    // },
    // {
    //     path: '/knowledgeBase',
    //     icon: 'ios-options-outline',
    //     name: 'knowledgeBase',
    //     title: '知识库',
    //     component: Main,
    //     isId: 10,
    //     show: true,
    //     status: true,
    //     children: [
    //         {
    //             path: '/serveKnowledgeBase',
    //             name: 'serveKnowledgeBase',
    //             auth: 'system/commondescr/index',
    //             component: commondescr.commondescrList,
    //             title: '服务字典',
    //             show: true,
    //             status: false,
    //         },
    //         {
    //             path: '/issueKnowledgeBase',
    //             name: 'issueKnowledgeBase',
    //             auth: 'system/commondescr/index',
    //             component: commondescr.publicList,
    //             title: '知识库',
    //             show: true,
    //             status: false,
    //         },
    //         {
    //             path: '/auditKnowledgeBase',
    //             name: 'auditKnowledgeBase',
    //             auth: 'system/commondescr/index',
    //             component: commondescr.processList,
    //             title: '知识库审核',
    //             show: true,
    //             status: false,
    //         },
    //     ]
    // },
    {
        path: '/device',
        icon: 'ios-options-outline',
        name: 'device',
        title: '设备台账',
        component: Main,
        isId: 10,
        show: true,
        status: true,
        children: [
            {
                path: '/device',
                name: 'device',
                title: '设备台账',
                component: temtmain,
                // auth: 'system/deviceretrieval/index',
                auth: 'system/device/index',
                show: true,
                status: false,
                children: [
                    {
                        path: 'deviceretrieval_list',
                        title: '使用中',
                        show: true,
                        name: 'deviceretrieval_list',
                        auth: '',
                        component: device.deviceretrievalList,
                        status: false,
                    },
                    {
                        path: 'device_list',
                        title: '库存中',
                        show: true,
                        name: 'device_list',
                        auth: '',
                        component: device.deviceList,
                        status: false,
                    }, {
                        path: 'devicedamage_list',
                        title: '已损坏',
                        show: true,
                        name: 'devicedamage_list',
                        auth: '',
                        component: device.devicedamageList,
                        status: false,
                    }, {
                        path: 'devicescrap_list',
                        title: '已报废',
                        show: true,
                        name: 'devicescrap_list',
                        auth: '',
                        component: device.devicescrapList,
                        status: false,
                    }, {
                        path: 'devicestandby_list',
                        title: '备用库',
                        show: true,
                        name: 'devicestandby_list',
                        auth: '',
                        component: device.devicestandbyList,
                        status: false,
                    }, {
                        path: 'Emptycode_list',
                        title: '空码库',
                        show: true,
                        name: 'Emptycode_list',
                        auth: '',
                        component: device.EmptycodeList,
                        status: false,
                    },
                    {
                        path: 'deviceRecordIndex',
                        title: '设备档案',
                        name: 'deviceRecordIndex',
                        auth: '',
                        show: true,
                        status: false,
                        component: device.deviceRecordIndex
                    },
                    {
                        path: 'device_edit',
                        title: '编辑',
                        show: true,
                        status: false,
                        name: 'device_edit',
                        auth: '',
                        component: device.deviceEdit
                    },
                    {
                        path: 'deviceRecordretrieval_list',
                        title: '入库记录',
                        name: 'deviceRecordretrieval_list',
                        auth: '',
                        show: true,
                        status: false,
                        component: device.deviceRecordretrievalList
                    },
                    {
                        path: 'deviceTakeStockList_list',
                        title: '盘点记录',
                        name: 'deviceTakeStockList_list',
                        auth: '',
                        show: true,
                        status: false,
                        component: device.deviceTakeStockList
                    },
                    {
                        path: 'deviceAssociation_list_cus',
                        title: '关联记录',
                        show: true,
                        status: false,
                        name: 'deviceAssociation_list_cus',
                        auth: '',
                        component: device.deviceAssociation
                    },
                    {
                        path: 'deviceRecorddamage_list',
                        title: '损坏记录',
                        name: 'deviceRecorddamage_list',
                        auth: '',
                        show: true,
                        status: false,
                        component: device.deviceRecorddamageList
                    },
                    {
                        path: 'deviceRecordcheckout_list',
                        title: '出库记录',
                        show: true,
                        status: false,
                        name: 'deviceRecordcheckout_list',
                        auth: '',
                        component: device.deviceRecordcheckoutList
                    },
                    {
                        path: 'deviceRecordscrap_list',
                        title: '报废记录',
                        show: true,
                        status: false,
                        name: 'deviceRecordscrap_list',
                        auth: '',
                        component: device.deviceRecordscrapList
                    },
                    {
                        path: 'deviceMaintenance_list',
                        title: '维修记录',
                        show: true,
                        status: false,
                        name: 'deviceMaintenance_list',
                        auth: '',
                        component: device.deviceMaintenanceList
                    },
                    {
                        path: 'device_add',
                        title: '创建资产',
                        show: true,
                        status: false,
                        name: 'device_add',
                        auth: '',
                        component: device.deviceEdit
                    },
                ],
            },
            {
                path: '/copy_accounts',
                name: 'copy_accounts',
                title: '设备抄张',
                component: temtmain,
                // auth: 'system/deviceretrieval/index',
                auth: 'system/copy_accounts/index',
                show: true,
                status: false,
                children: [
                    {
                        path: 'copy_accounts',
                        title: '设备抄张',
                        show: true,
                        name: 'copy_accounts',
                        auth: 'system/copy_accounts/index',
                        component: copyAccounts.copyAccountsList,
                        status: false,
                    },
                    {
                        path: 'copy_accounts_edit',
                        title: '抄张',
                        show: true,
                        name: 'copy_accounts_edit',
                        auth: 'system/copy_accounts/index',
                        component: copyAccounts.addRecord,
                        status: false,
                    },
                ],
            },
            {
                path: '/first_check',
                name: 'first_check',
                title: '初次盘点',
                component: temtmain,
                // auth: 'system/deviceretrieval/index',
                auth: 'system/first_check/index',
                show: customerId == 0 ? true : false,
                status: false,
                children: [
                    {
                        path: 'first_check',
                        title: '初次盘点',
                        show: customerId == 0 ? true : false,
                        name: 'first_check',
                        auth: 'system/first_check/index',
                        component: device.firstCheck,
                        status: false,
                    },
                ],
            },
            // {
            //     path: '/device_seetings',
            //     name: 'device_seetings',
            //     title: '设置',
            //     component: temtmain,
            //     // auth: 'system/deviceretrieval/index',
            //     auth: 'system/device/index',
            //     show: true,
            //     status: false,
            //     children: [

            //     ]
            // }
        ]
    },
    {
        path: '/patient',
        // icon: 'ios-sync',
        name: 'patient',
        title: '手术转运',
        isId: 11,
        component: Main,
        auth: 'system/PatientWork/await',
        show: true,
        status: false,
        children: [
            {
                path: '/PatientWork_await',
                name: 'PatientWork_await',
                auth: 'system/PatientWork/await',
                component: temtmain,
                title: '转运列表',
                show: true,
                status: false,
                children: [
                    {
                        path: 'PatientWork_await',
                        name: 'PatientWork_await',
                        auth: 'system/PatientWork/await',
                        component: PatientWork.PatientWorkList,
                        title: '转运列表',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'PatientWork_add',
                        name: 'PatientWork_add',
                        auth: '',
                        component: PatientWork.PatientWorkEdit,
                        title: '转运编辑',
                        show: true,
                        status: false,
                    }, {
                        path: 'Patient_add',
                        name: 'Patient_add',
                        auth: '',
                        component: PatientWork.PatientEdit,
                        title: '手术人员编辑',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'PatientWork_info',
                        name: 'PatientWork_info',
                        auth: '',
                        component: PatientWork.PatientWorkInfo,
                        title: '转运详情',
                        show: true,
                        status: false,
                    },
                ]
            },

        ]
    },
    {
        path: '/commonSettings',
        icon: 'ios-options-outline',
        name: 'commonSettings',
        title: '常用设置',
        component: Main,
        isId: 8,
        auth: '',
        show: true,
        status: false,
        children: [
            // {
            //     path: '/commondescrIndex',
            //     name: 'commondescrIndex',
            //     auth: 'system/commondescr/index',
            //     icon: 'ios-bookmarks-outline',
            //     component: Main,
            //     title: '知识库',
            //     show: true,
            //     status: false,
            //     children: [
            // {
            //     path:'serveKnowledgeBase',
            //     name:'serveKnowledgeBase',
            //     auth:'system/commondescr/index',
            //     component:
            // },

            // {
            //     path: 'knowledgeBaseDetails',
            //     name: 'knowledgeBaseDetails',
            //     auth: '',
            //     component: commondescr.commondescrDetails,
            //     title: '知识库详情',
            //     show: false,
            //     status: false,
            // },
            {
                path: '/commondescr_add',
                title: '创建语句',
                show: false,
                name: 'commondescr_add',
                auth: '',
                component: commondescr.commondescrEdit
            },
            {
                path: '/commondescr_edit',
                title: '编辑语句',
                show: false,
                name: 'commondescr_edit',
                auth: '',
                component: commondescr.commondescrEdit
            },
            //     ]
            // },



            {
                path: '/templateManagement',
                title: '模板管理',
                show: true,
                name: 'templateManagement_list',
                auth: 'system/templateManagement/index',
                component: inspection.templateManagementList,
                status: false,
            },
            {
                path: '/templateManagement_add',
                title: '创建模板',
                show: false,
                name: 'templateManagement_add',
                auth: '',
                component: inspection.templateManagementEdit
            },
            {
                path: '/templateManagement_edit',
                title: '编辑模板',
                show: false,
                name: 'templateManagement_edit',
                auth: '',
                component: inspection.templateManagementEdit
            },




            // {
            //     path: 'list',
            //     title: '知识库分类',
            //     name: 'knowledgeBaseClass_list',
            //     show: true,
            //     status: false,
            //     auth: 'system/knowledgeBaseClass/index',
            //     component: knowledgeBase.knowledgeBaseClassList
            // },
            // {
            //     path: 'list',
            //     title: '知识库标签',
            //     show: true,
            //     status: false,
            //     name: 'knowledgeBaseTag_list',
            //     auth: 'system/knowledgeBaseTag/index',
            //     component: knowledgeBase.knowledgeBaseTagList
            // },
            // {
            //     path: 'add',
            //     title: '创建标签',
            //     show: false,
            //     name: 'knowledgeBaseTag_add',
            //     auth: '',
            //     component: knowledgeBase.knowledgeBaseTagEdit
            // },
            // {
            //     path: 'edit',
            //     title: '编辑标签',
            //     show: false,
            //     name: 'knowledgeBaseTag_edit',
            //     auth: '',
            //     component: knowledgeBase.knowledgeBaseTagEdit
            // },
            // {
            //     path: 'add',
            //     title: '创建分类',
            //     show: false,
            //     name: 'knowledgeBaseClass_add',
            //     auth: '',
            //     component: knowledgeBase.knowledgeBaseClassEdit
            // },
            // {
            //     path: 'edit',
            //     title: '编辑分类',
            //     show: false,
            //     name: 'knowledgeBaseClass_edit',
            //     auth: '',
            //     component: knowledgeBase.knowledgeBaseClassEdit
            // },
            {
                path: '/feedback',
                title: '投诉管理',
                name: 'feedback_list',
                auth: '/admin/feedback/lists',
                component: feedback.feedbackList,
                show: true,
                status: false
            },


        ],
    },

    {
        path: '/fileDownload_index',
        icon: 'ios-cog-outline',
        name: 'fileDownload_index',
        title: '资源下载',
        isId: 12,
        component: Main,
        show: true,
        status: true,
        children: [{
            path: '/fileDownload',
            name: 'fileDownload',
            auth: 'system/itsmresourcedownload/index',
            component: commondescr.fileDownload,
            title: '资源下载',
            show: true,
            status: false,
        },]

    },

    {
        path: '/service_reporting_index',
        icon: 'ios-cog-outline',
        name: 'service_reporting_index',
        title: '报表中心',
        isId: 13,
        component: Main,
        show: true,
        status: true,
        children: [{
            path: "/service_reporting",
            name: "service_reporting",
            auth: "/admin/reporting/index",
            title: "服务报告",
            component: temtmain,
            show: true,
            status: false,
            children: [{
                path: "service_reporting",
                name: "service_reporting",
                auth: "/admin/reporting/index",
                component: Analysis.serviceReportingIndex,
                title: "服务报告",
                show: true,
                status: false,
            },
            {
                path: "service_reporting_two",
                name: "service_reporting_two",
                auth: "/admin/reporting/index",
                component: Analysis.reportingList,
                title: "服务报告",
                show: true,
                status: false,
            },
            ]
        },
        {
            path: '/accounting_box',
            title: '核算报告',
            name: 'accounting_box',
            auth: '/admin/Accounting/index',
            component: temtmain,
            show: true,
            status: false,
            children: [
                {
                    title: '成本',
                    path: "Accounting_report",
                    name: "Accountingreport",
                    auth: "/admin/Accounting/index",
                    component: Accounting.AccountingReportingIndex,
                    show: true,
                    status: false,
                },
                {
                    title: '科室',
                    path: "Accounting_List",
                    name: "AccountingList",
                    auth: "/admin/Accounting/index",
                    component: Accounting.Accountinglist,
                    show: true,
                    status: false,
                },
                {
                    path: "Accounting_install",
                    name: "Accountinginstall",
                    auth: "/admin/Accounting/index",
                    component: Accounting.AccountinginstallIndex,
                    title: "核算设置",
                    show: true,
                    status: false,
                },
                {
                    path: "accounting_detail",
                    name: "accountingDetail",
                    auth: "/admin/Accounting/index",
                    component: Accounting.accountingDetail,
                    title: "明细",
                    show: true,
                    status: false,
                },
            ]
        },
        {
            path: '/copy_a_summary_box',
            title: '抄张汇总',
            name: 'copy_a_summary_box',
            auth: '/admin/copy_a_summary/index',
            component: temtmain,
            show: true,
            status: false,
            children: [
                {
                    title: '核算报表',
                    path: "accounting_statement",
                    name: "accounting_statement",
                    auth: "/admin/copy_a_summary/index",
                    component: copyAccounts.accountingStatement,
                    show: true,
                    status: false,
                },
                {
                    title: '抄张汇总',
                    path: "copy_a_summary",
                    name: "copy_a_summary",
                    auth: "/admin/copy_a_summary/index",
                    component: copyAccounts.copyASummary,
                    show: true,
                    status: false,
                },

                {
                    path: 'paperType_list',
                    title: '纸张费率',
                    name: 'paperType_list',
                    auth: '/admin/copy_a_summary/index',
                    component: copyAccounts.paperTypeList,
                    show: true,
                    status: false
                },
                {
                    path: 'paperType_edit',
                    title: '编辑纸张费率',
                    name: 'paperType_edit',
                    auth: '/admin/copy_a_summary/index',
                    component: copyAccounts.paperTypeEdit,
                    show: true,
                    status: false,
                },

            ]
        },
        {
            path: '/personnel_efficiency',
            title: '人员效率',
            name: 'personnel_efficiency',
            auth: '/admin/personnel_efficiency/index',
            component: temtmain,
            show: true,
            status: false,
            children: [
                {
                    title: '人员效率',
                    path: "personnel_efficiency_list",
                    name: "personnel_efficiency_list",
                    auth: "/admin/personnel_efficiency/index",
                    component: Analysis.EightInfo,
                    show: true,
                    status: false,
                },
            ]
        },
        {
            path: '/performance_new',
            // icon: "ios-stats-outline",
            title: '绩效统计',
            name: 'performance_new',
            component: temtmain,
            auth: 'system/fraction_new/index',
            show: true,
            status: false,
            children: [{
                path: 'performance_new_list',
                title: '绩效列表',
                name: 'performance_new_list',
                component: performanceNew.performanceNewList,
                show: true,
                status: false,
            }, {
                path: 'performance_new_detailList',
                title: '绩效详情',
                name: 'performance_new_detailList',
                auth: '',
                component: performanceNew.detailList,
                show: true,
                status: false,
            }, {
                path: 'performance_details',
                title: '绩效详情',
                name: 'performance_details',
                auth: 'system/fraction/index',
                component: performance.PerformanceDetails,
                show: true,
                status: false,
            }

            ]
        },
        {
            path: '/performance',
            // icon: "ios-stats-outline",
            title: '绩效评分',
            name: 'performance',
            component: temtmain,
            auth: 'system/fraction/index',
            show: true,
            status: false,
            children: [{
                path: 'performance_list',
                title: '绩效列表',
                name: 'performance_list',
                component: performance.PerformanceList,
                show: true,
                status: false,
            }, {
                path: 'performance_manage',
                title: '绩效管理',
                name: 'performance_manage',
                auth: '',
                component: performance.PerformanceManage,
                show: true,
                status: false,
            }, {
                path: 'performance_details',
                title: '绩效详情',
                name: 'performance_details',
                auth: 'system/fraction/index',
                component: performance.PerformanceDetails,
                show: true,
                status: false,
            }

            ]
        },
        ]
    },

    {
        path: '/userInfo_index',
        icon: 'ios-cog-outline',
        name: 'userInfo_index',
        title: '个人中心',
        component: Main,
        isId: 14,
        show: true,
        status: true,
        children: [{
            path: '/userInfo_Index',
            name: 'userInfo_Index',
            // auth: 'system/UserInfo/index',
            component: userInfo.userInfoindex,
            title: '个人中心',
            show: true,
            status: false,
        },]
    },

    {
        path: '/tool',
        icon: 'ios-cog-outline',
        name: 'tool',
        title: '系统设置',
        isId: 9,
        component: Main,
        show: true,
        status: true,
        children: [
            {
                path: '/configure_list',
                title: '配置管理',
                name: 'configure_list',
                auth: '/admin/configure/lists',
                component: temtmain,
                show: true,
                status: false,
                children: [
                    {
                        path: '/configure_list',
                        title: '配置管理',
                        name: 'configure_list',
                        auth: '/admin/configure/lists',
                        component: configure.configureList,
                        show: true,
                        status: false
                    },
                    {
                        path: 'configure_add',
                        title: '创建配置',
                        show: true,
                        name: 'configure_add',
                        auth: '',
                        component: configure.configureEdit,
                        status: false
                    },
                    {
                        path: 'configure_edit',
                        title: '编辑配置',
                        show: true,
                        name: 'configure_edit',
                        auth: '',
                        component: configure.configureEdit,
                        status: false
                    },
                ]
            },
            {
                path: '/customer_list',
                name: 'customer_list',
                auth: '/admin/customer/list',
                component: temtmain,
                title: '客户管理',
                show: true,
                status: false,
                children: [
                    {
                        path: 'customer_list',
                        name: 'customer_list',
                        auth: '/admin/customer/list',
                        component: Customer.CustomerList,
                        title: '客户管理',
                        show: true,
                        status: false,

                    },
                    {
                        path: 'customer_add',
                        title: '新增客户',
                        show: true,
                        name: 'customer_add',
                        auth2: '',
                        component: Customer.CustomerEdit,
                        status: false
                    },
                    {
                        path: 'customer_edit',
                        title: '编辑客户',
                        show: true,
                        name: 'customer_edit',
                        auth2: '',
                        component: Customer.CustomerEdit,
                        status: false
                    },
                ]
            },
            {
                path: '/version_list',
                name: 'version_list',
                auth: '/admin/version/list',
                component: temtmain,
                title: '版本管理',
                show: true,
                status: false,
                children: [
                    {
                        path: 'version_list',
                        name: 'version_list',
                        auth: '/admin/version/list',
                        component: Version.VersionList,
                        title: '版本管理',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'version_weapp_list',
                        name: 'version_weapp_list',
                        auth: '/admin/version/list',
                        component: Version.weappList,
                        title: '移动版本',
                        show: true,
                        status: false,
                    },
                    {
                        path: 'version_add',
                        title: '新增版本',
                        show: true,
                        name: 'version_add',
                        auth2: '',
                        component: Version.VersionEdit,
                        status: false,
                    },
                    {
                        path: 'version_weapp_add',
                        title: '新增移动版本',
                        show: true,
                        name: 'version_weapp_add',
                        auth2: '',
                        component: Version.weappEdit,
                        status: false,
                    },
                    {
                        path: 'version_weapp_edit',
                        title: '编辑移动版本',
                        show: true,
                        name: 'version_weapp_edit',
                        auth2: '',
                        component: Version.weappEdit,
                        status: false,
                    },
                    {
                        path: 'version_edit',
                        title: '编辑版本',
                        show: true,
                        name: 'version_edit',
                        auth2: '',
                        component: Version.VersionEdit,
                        status: false,
                    },
                ]
            },
            {
                path: '/job_list',
                title: '定时任务',
                name: 'job_list',
                auth: '/admin/job/lists',
                component: temtmain,
                show: true,
                status: false,
                children: [
                    {
                        path: 'job_list',
                        title: '定时任务',
                        name: 'job_list',
                        auth: '/admin/job/lists',
                        component: job.jobList,
                        show: true,
                        status: false
                    },
                    {
                        path: 'job_add',
                        title: '创建任务',
                        show: true,
                        status: false,
                        name: 'job_add',
                        auth: '',
                        component: job.jobEdit
                    },
                    {
                        path: 'job_edit',
                        title: '编辑任务',
                        show: true,
                        status: false,
                        name: 'job_edit',
                        auth: '',
                        component: job.jobEdit
                    },
                ]
            },
            {
                path: '/operlog_list',
                title: '操作日志',
                name: 'operlog_list',
                auth: '/admin/operlog/lists',
                component: temtmain,
                show: true,
                status: false,
                children: [
                    {
                        path: 'operlog_list',
                        title: '操作日志',
                        name: 'operlog_list',
                        auth: '/admin/operlog/lists',
                        component: logmanger.operlogList,
                        show: true,
                        status: false
                    }
                ]
            }, {
                path: '/logininfor_list',
                title: '登录日志',
                name: 'logininfor_list',
                auth: '/admin/logininfor/lists',
                component: temtmain,
                show: true,
                status: false,
                children: [
                    {
                        path: 'logininfor_list',
                        title: '登录日志',
                        name: 'logininfor_list',
                        auth: '/admin/logininfor/lists',
                        component: logmanger.logininforList,
                        show: true,
                        status: false
                    },
                ]
            },
            // {
            //     path: '/notice_add',
            //     title: '新增公告',
            //     show: false,
            //     name: 'notice_add',
            //     auth: '',
            //     component: Notice.NoticeEdit,
            //     status: false
            // },
            // {
            //     path: '/notice_edit',
            //     title: '编辑公告',
            //     show: false,
            //     name: 'notice_edit',
            //     auth: '',
            //     component: Notice.NoticeEdit,
            //     status: false
            // },
            {
                path: '/auth_rule_list',
                title: '权限规则',
                name: 'auth_rule_list',
                auth: '/admin/authrule/lists',
                component: temtmain,
                show: true,
                status: false,
                children: [
                    {
                        path: 'auth_rule_list',
                        title: '权限规则',
                        name: 'auth_rule_list',
                        auth: '/admin/authrule/lists',
                        component: Auth.AuthRuleList,
                        show: true,
                        status: false
                    },
                    {
                        path: "weapp_client_list",
                        title: '用户列表',
                        name: 'weapp_client_list',
                        auth: '/admin/authrule/lists',
                        component: weappPermissionList.clientList,
                        show: true,
                        status: false,
                    },
                    {
                        path: "weapp_engineer_list",
                        title: '维修列表',
                        name: 'weapp_engineer_list',
                        auth: '/admin/authrule/lists',
                        component: weappPermissionList.engineerList,
                        show: true,
                        status: false,
                    },
                    {
                        path: "add_weapp_item",
                        title: '新增菜单',
                        name: 'add_weapp_item',
                        auth: '/admin/authrule/lists',
                        component: weappPermissionList.edit,
                        show: true,
                        status: false,
                    },
                    {
                        path: 'auth_rule_add',
                        title: '创建权限',
                        show: true,
                        name: 'auth_rule_add',
                        auth2: '',
                        component: Auth.AuthRuleEdit,
                        status: false,
                    },
                    {
                        path: 'auth_rule_edit',
                        title: '编辑权限',
                        show: true,
                        name: 'auth_rule_edit',
                        auth2: '',
                        component: Auth.AuthRuleEdit,
                        status: false,
                    },
                ]
            },
            {
                path: '/developmentlog',
                show: true,
                title: '开发日志',
                name: 'developmentlog_list',
                auth: '/admin/developmentlog/lists',
                component: developmentlog.developmentlogList,
                status: false,
            },
            {
                path: '/add',
                title: '创建日志',
                show: false,
                name: 'developmentlog_add',
                auth: '',
                component: developmentlog.developmentlogEdit,
                status: false,
            },

            {
                path: '/edit',
                title: '编辑日志',
                show: false,
                name: 'developmentlog_edit',
                auth: '',
                component: developmentlog.developmentlogEdit,
                status: false,
            },


            {
                path: '/run_list',
                title: '任务执行一次',
                show: false,
                name: 'run_list',
                auth: '',
                component: job.jobrun
            },
        ],
    },
    {
        path: '/development',
        icon: 'ios-git-commit',
        name: 'development',
        title: '更新日志',
        show: true,
        status: false,
        component: Main,
        children: [{
            path: '/developmentlogindex',
            title: '开发日志',
            name: 'developmentlog_index',
            auth: 'developmentlog_index',
            component: developmentlog.developmentlogindex
        }],
    },
]


// console.log("_appRouter:", _appRouter);
// 不作为Main组件的子页面展示的页面单独写，如下
export const page404 = {
    path: '/*', name: 'error-404', meta: {
        title: '404-页面不存在',
    }, component: (resolve) => {
        require(['@/views/error/404.vue'], resolve)
    },
}
export const pageweixiu = {
    path: '/*', name: 'error_weixiu', meta: {
        title: '用户权限不足',
    }, component: (resolve) => {
        require(['@/views/weiXiuError.vue'], resolve)
    },
}

export const page403 = {
    path: '/403', meta: {
        title: '403-权限不足',
    }, name: 'error-403', component: (resolve) => {
        require(['@//views/error/403.vue'], resolve)
    },
}

export const page500 = {
    path: '/500', meta: {
        title: '500-服务端错误',
    }, name: 'error-500', component: (resolve) => {
        require(['@/views/error/500.vue'], resolve)
    },
}

export const locking = {
    path: '/locking', name: 'locking', component: (resolve) => {
        require(['@/views/components/main/lockscreen/components/locking-page.vue'], resolve)
    },
}

Array.prototypeNaNpxove = function (val) {
    if (isNaN(val) || val > this.length) {
        return false
    }
    for (var i = 0, n = 0; i < this.length; i++) {
        if (this[i] != this[val]) {
            this[n++] = this[i]
        }
    }
    this.length -= 1
}

// 通过用户权限筛选路由  !仅处理2层路由
// 用户权限表
function _doRules(arr) {
    // const rules = $data.get('auth', 'userAuths')
    const rules = $data.get('auth', 'auths')
    const arr_temp = []
    const tt = _.compact(arr)
    for (let i = 0; i < tt.length; i++) {
        let item = tt[i]
        // 设置标题
        item.meta = item.meta || {}
        item.meta.title = item.meta.title || item.title || ''
        // 判断子路由
        if (item.children && item.children.length > 0) {
            item.children = _doRules(item.children)
        }
        // 判断自身
        if (true && item.auth && _.findIndex(rules, { url: item.auth }) < 0) {
            // 拒绝， 去除路由
            // console.log(item.auth, -1)
        } else {
            // 添加
            arr_temp.push(item)
        }
    }
    return arr_temp
}

// 处理appRouter、otherRouter
_appRouter = _doRules(_appRouter)
_weixiuRouter = _doRules(_weixiuRouter)
_cusRouter = _doRules(_cusRouter)
_otherRouter.children = _doRules(_otherRouter.children)
_weixiuOtherRouter.children = _doRules(_weixiuOtherRouter.children)
_cusOtherRouter.children = _doRules(_cusOtherRouter.children)
export const appRouter = _appRouter
export const weixiuRouter = _weixiuRouter
export const cusRouter = _cusRouter
export const otherRouter = _otherRouter
export const weixiuOtherRouter = _weixiuOtherRouter
export const cusOtherRouter = _cusOtherRouter
// console.log('routexxxxxxxx appRouter', appRouter);
// console.log('routexxxxxxxx otherRouter', otherRouter);

// 所有上面定义的路由都要写在下面的routers里
export const routers = [qyRouter, errorWeiXiuRouter, loginRouter, allIndexRouter, deepSeekAIRouter, downloadRouter, otherRouter, weixiuOtherRouter, cusOtherRouter, locking, ...appRouter, ...weixiuRouter, ...cusRouter, page500, page403, pageweixiu, page404]
